import core from '../../../js/core/core'
import EventBus from '../../events/event-bus'
import moment from 'moment'
import vueCookie from 'vue-cookie'
import Vue from 'vue'
import DateFilter from '@/vue/filters/date'

import * as types from '../mutation-types'

// initial state
const state = {
  eventList: [],
  otrSportList: [],
  rbeventList: [],
  favrbeventList: [],
  eventAllBet: null,
  mainMarketBet: null,
  sortedEventList: [],
  sortedRBEventList: [],
  sortedFavRbEventList: [],
  sortedMatchEventList: [],
  firstEvent: [],
  testshow: false,
  showRightBanner: true,
  totalPage: 1,
  sportList: null,
  hot_sportList: null,
  bettypeList: null,
  sportBettypeList: null,
  oddTypesList: null,
  earlyParlayDateList: null,
  selectedEarlyParlayDate: 99,
  selectedSport: null,
  selectedBettype: null,
  selectedPlytype: null,
  selectedMarket: '1',
  prevMarket: '1',
  selectedSort: '2',
  selectedShow: '2',
  selectedPage: 1,
  selectedMatchAllBet: false,
  hotSchedule: false,
  selectedAllBet: false,
  matchAllBet: false,
  selectedAllBetNew: false,
  sportTableLang: null,
  sportAllBetLang: null,
  int_fullHalfTime: 1,
  arr_leagueList: null,
  merge_leagueList: null,
  changeOdds: false,
  market: {
    inPlayMarket: {
      key: '3',
      lang: window.lang.welcomeInPlay,
      betLang: window.lang.betInPlay,
    },
    tdyMarket: {
      key: '1',
      lang: window.lang.welcomeTdyMarket,
      betLang: window.lang.betTdyMarket,
    },
    earlyMarket: {
      key: '2',
      lang: window.lang.welcomeEarlyMarket,
      betLang: window.lang.betEarlyMarket,
    },
    hotSportMarket: {
      key: '5',
      lang: window.lang.hotSport,
      betLang: window.lang.hotSport,
    },
    favMarket: {
      key: '99',
      lang: window.lang.myFav,
      betLang: window.lang.myFav,
    },
  },
  sortTypes: {
    competition: {
      key: '2',
      lang: 'SPORT_TABLE.SUBHEADER_SORTBY_COMPETITION',
    },
    time: {
      key: '1',
      lang: 'SPORT_TABLE.SUBHEADER_SORTBY_TIME',
    },
  },
  sortShowTypes: {
    singleLine: {
      key: '1',
      lang: 'SPORT_TABLE.SUBHEADER_SINGLELINE',
    },
    doubleLine: {
      key: '2',
      lang: 'SPORT_TABLE.SUBHEADER_DOUBLELINE',
    },
    fullTime: {
      key: '3',
      lang: 'SPORT_TABLE.FULL_TIME',
    },
    halfTime: {
      key: '4',
      lang: 'SPORT_TABLE.HALF_TIME',
    },
  },
  marketType: {
    allMarket: {
      key: '1',
      lang: 'SPORT_TABLE.ALL_MARKET',
    },
    mainMarket: {
      key: '2',
      lang: 'SPORT_TABLE.MAIN_MARKET',
    },
    otherMarket: {
      key: '3',
      lang: 'SPORT_TABLE.OTHER_MARKET',
    },
  },
  arr_selectedLeagueList: [],
  favouriteEvents: {},
  favouriteOTREvents: {},
  favouriteOTREventsCount:0,
  favouriteEventsCount:0,
  favouriteRBEventsCount:0,
  favouriteLgeEvents: {},
  sportInPlayEvents: null,
  sportAllEvents: {},
  bool_leagueToggle: false,
  showFavEvents: false,
  sportPrevIsMulp: false,
  highlightedCell: null,
  parlaySelected: null,
  isGameBannerSelected: false,
  selectedLeagues: 0,
  totalLeagues: 0,
  sportLeagueWindowEvent: null,
  moreBetLoading: false,
  moreBetToggle: [],
  allSportCount: {},
  checked: true,
  foldopenAllBet: true,
  foldopenFirstEvent: true,
  showLeagueTeam: false,
  showLeagueSearch:false,
  istodayRB: false,
  open_RBMarket: false,
  selectedInPlaySport: false,
  allBetReloading: false,
  right_allBetReloading: false,
  arr_earlyEventCountByDate:{},
  show_Unfold: false, //control right menu expand full bt
  show_Fold: false,
  selected_AllBetTab:  {
    'ab': 'all', //'hot',
    'firstEvent': 'all' //'hot'
  },
  // unfold_AllSc:false,
  unfold_AllSc: {
    'N1': {
      '1': false
    },
  },
  miniNormal : window.innerWidth >= 1440 ? false:true,
  frameWidthHeight: {
    width:{
      minFull:1440, // Window minimun Width
      currentWidth :window.innerWidth, // Current Window Width
      LeftPage_normal:234, // Left menu normal width
      LeftPage_mini :69,   // Left menu mini width
      LeftPage_current : window.innerWidth >= 1440 ? 234:69, // Current left menu width
      CenterPage_min :775,
      CenterPage_current :775, // Current center odd page width
      RightPage_min :432,
      RightPage_max :570,
      RightPage_current :430, // Current right odd page width
      
    },
    height:{
      header:96,
      currentHeight:window.innerHeight
    },
    leagueTeam:{
      betBoxWidthMin:85,
      betBoxWidthMax:118,
      leagueBoxWidthMin:238,
      timeColumn: 77,
      favColumn:39,
      columnCountBet:6,
      columnCountBetShow:13,
    }
  },
  livetv:{
    eveid:null,
    link:null
  },
  filterEventArr: null,
  showRBLgeEve: [],
  showLgeEve: {},
  sportIdArr: {
    "1": "N1",
    "2": "N2",
    "3": "N3",
    "21": "N21",
    "12": "N12",
    "7": "N7",
    "13": "N13",
    "14": "N14",
    "15": "N15",
    "19": "N19",
    "20": "N20",
    "23": "N23",
  },
  otrBetType: {
    betTypId: "6",
    betTypLang: 'CONFIG_LANG.LBL_GAME_OUTRIGHT' ,
    sprtId: "G98",  //default G98(All)
    tmpltId: "11",
  },
  isChangeTemplate: true,
  selectedEventId: null,
  isParlayTab: false,
  previousBettype: null,
  gameBannerSportCount: [],
  gameBannerSportId: null,
  rightBoardChange: null,
  simpleSport: null,
  updateRightBoardToggle: false,
  previousLeftEvent: [],
  bettypeFeature: window.bettype_feature,
  specialEvent: false,
  specialEventList: {
    'id': '',
    'sprtId': ''
  },
  refreshToggle: false,
  ShowUpDown: true,
  isLiveOn: window._isLiveOn,
}

// getters
const getters = {
  eventList: state => state.eventList,
  rbeventList: state => state.rbeventList,
  favrbeventList: state => state.favrbeventList,
  eventAllBet: state => state.eventAllBet,
  mainMarketBet: state => state.mainMarketBet,
  sortedEventList: state => state.sortedEventList,
  sortedRBEventList: state => state.sortedRBEventList,
  sortedFavRbEventList: state => state.sortedFavRbEventList,
  sortedMatchEventList: state => state.sortedMatchEventList,
  firstEvent: state => state.firstEvent,
  testshow: state => state.testshow,
  showRightBanner: state => state.showRightBanner,
  totalPage: state => state.totalPage,
  sportList: state => state.sportList,
  hot_sportList: state => state.hot_sportList,
  bettypeList: state => state.bettypeList,
  sportBettypeList: state => state.sportBettypeList,
  oddTypesList: state => state.oddTypesList,
  earlyParlayDateList: state => state.earlyParlayDateList,
  selectedEarlyParlayDate: state => state.selectedEarlyParlayDate,
  selectedSort: state => state.selectedSort,
  selectedShow: state => state.selectedShow,
  selectedSport: state => state.selectedSport,
  selectedBettype: state => state.selectedBettype,
  selectedMarket: state => state.selectedMarket,
  prevMarket: state => state.prevMarket,
  selectedPage: state => state.selectedPage,
  selectedMatchAllBet: state => state.selectedMatchAllBet,
  hotSchedule: state => state.hotSchedule,
  selectedAllBet: state => state.selectedAllBet,
  matchAllBet: state => state.matchAllBet,
  selectedAllBetNew: state => state.selectedAllBetNew,
  sportTableLang: state => state.sportTableLang,
  sportAllBetLang: state => state.sportAllBetLang,
  market: state => state.market,
  sortTypes: state => state.sortTypes,
  sortShowTypes: state => state.sortShowTypes,
  marketType: state => state.marketType,
  bool_leagueToggle: state => state.bool_leagueToggle,
  int_fullHalfTime: state => state.int_fullHalfTime,
  arr_leagueList: state => state.arr_leagueList,
  merge_leagueList: state => state.merge_leagueList,
  arr_selectedLeagueList: state => state.arr_selectedLeagueList,
  favouriteEvents: state => state.favouriteEvents,
  favouriteOTREvents: state => state.favouriteOTREvents,
  favouriteOTREventsCount: state => state.favouriteOTREventsCount,
  favouriteEventsCount: state => state.favouriteEventsCount,
  favouriteRBEventsCount: state => state.favouriteRBEventsCount,
  favouriteLgeEvents: state => state.favouriteLgeEvents,
  showFavEvents: state => state.showFavEvents,
  sportInPlayEvents: state => state.sportInPlayEvents,
  sportAllEvents: state => state.sportAllEvents,
  sportPrevIsMulp: state => state.sportPrevIsMulp,
  highlightedCell: state => state.highlightedCell,
  parlaySelected: state => state.parlaySelected,
  isGameBannerSelected: state => state.isGameBannerSelected,
  selectedLeagues: state => state.selectedLeagues,
  totalLeagues: state => state.totalLeagues,
  sportLeagueWindowEvent: state => state.sportLeagueWindowEvent,
  moreBetLoading: state => state.moreBetLoading,
  moreBetToggle: state => state.moreBetToggle,
  allSportCount: state => state.allSportCount,
  checked: state => state.checked,
  foldopenAllBet: state => state.foldopenAllBet,
  foldopenFirstEvent: state => state.foldopenFirstEvent,
  changeOdds: state => state.changeOdds,
  showLeagueTeam: state => state.showLeagueTeam,
  showLeagueSearch: state => state.showLeagueSearch,
  istodayRB: state => state.istodayRB,
  open_RBMarket: state => state.open_RBMarket,
  selectedInPlaySport: state => state.selectedInPlaySport,
  allBetReloading: state => state.allBetReloading,
  right_allBetReloading: state => state.right_allBetReloading,
  arr_earlyEventCountByDate: state => state.arr_earlyEventCountByDate,
  show_Unfold: state => state.show_Unfold,
  show_RightMenu: state => state.show_RightMenu,
  show_Fold: state => state.show_Fold,
  selected_AllBetTab: state => state.selected_AllBetTab,
  unfold_AllSc: state => state.unfold_AllSc,
  miniNormal: state => state.miniNormal,
  bWidth: state => state.bWidth, //base
  bCenterWidth: state => state.bCenterWidth,
  bCenterFullWidth: state => state.bCenterFullWidth,
  frameWidthHeight: state => state.frameWidthHeight,
  livetv: state => state.livetv,
  filterEventArr: state => state.filterEventArr,
  showRBLgeEve: state => state.showRBLgeEve,
  showLgeEve: state => state.showLgeEve,
  sportIdArr: state => state.sportIdArr,
  otrBetType: state => state.otrBetType,
  isChangeTemplate: state => state.isChangeTemplate,
  selectedEventId: state => state.selectedEventId,
  isParlayTab: state => state.isParlayTab,
  previousBettype: state => state.previousBettype,
  gameBannerSportCount: state => state.gameBannerSportCount,
  gameBannerSportId: state => state.gameBannerSportId,
  rightBoardChange: state => state.rightBoardChange,
  simpleSport: state => state.simpleSport,
  updateRightBoardToggle: state => state.updateRightBoardToggle,
  previousLeftEvent: state => state.previousLeftEvent,
  bettypeFeature: state => state.bettypeFeature,
  specialEvent: state => state.specialEvent,
  specialEventList: state => state.specialEventList,
  refreshToggle: state => state.refreshToggle,
  isLiveOn: state => state.isLiveOn,
  ShowUpDown: state => state.ShowUpDown,
}

// actions
const actions = {
  // actions
  getFilterEventList (context, payload) {

    let url = '/filter-event'
    if (this.getters.account.previewFlag == true) {
      url = '/filter-event-preview'
    }
    core.$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: {
        sorting: 1,
        sportid: payload.sportid,
      },
    }).done(((res)=> {
      this.commit('FILTER_EVENT', res.allEvent)
      if(res.earlyParlayDateList){
        this.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
      }
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  getSportCCL(context, payload) {
    payload = payload ? payload : {}
    if (!this.getters.account.previewFlag) {
      $('#balancesRefresh').addClass('loading-static-animation')
      var url = window._baseUrl + '/sport-ccl'
      var params = {}
      params.token = payload.token
      //if (payload.showB) {
      //params.showB = payload.showB
      //}
      core.$ajax({
        method: 'get',
        url: url,
        data: params,
      }).done(((res) => {
        var updateCurrCL = this.getters.account
        updateCurrCL.currCL = res.cleft

        var currCL_O = res.cleft * updateCurrCL.currUnit
        updateCurrCL.currCL_O = new Intl.NumberFormat().format(currCL_O)
        //if (payload.showB) {
        updateCurrCL.lastTrans = res.lastTrans
        updateCurrCL.outstanding = res.outstanding
        // }
        this.commit('ACCOUNT', updateCurrCL)
        $('#balancesRefresh').removeClass('loading-static-animation')
      }).bind(this)).catch((errRes) => {
        console.log(errRes)
      })
    }
  },
  getSportOdds(context, payload) {
    payload = payload ? payload : {}

    var url = ''

    if (this.getters.account.previewFlag == true) {
      url = window._baseUrl + '/sport-odds-preview'
    } else {
      url = window._baseUrl + '/sport-odds'
    }

    var httpMethod = 'post'
    var bettype = '';
    var plytype = '';
    var schedule = '';
    
    if (payload.sportId != null) {
      bettype = payload.sportId;
      plytype = "1";
      schedule = '2';
    } else {
      bettype = this.getters.selectedBettype.sprtId
      plytype = this.getters.selectedBettype.betTypId
      if(this.getters.selectedBettype.betTypId == '5' && !this.getters.isParlayTab){
        plytype = this.getters.previousBettype && this.getters.previousBettype.bettype? this.getters.previousBettype.bettype.betTypId:'1'
      }
      schedule = this.getters.selectedMarket;
      if (payload.scheduleMarket != '' && payload.scheduleMarket != undefined) {
        schedule = payload.scheduleMarket
      }
    }

    // Handle inplay without affected "today/early"
    if(this.getters.open_RBMarket){
      schedule = this.getters.market.inPlayMarket.key
      bettype = this.getters.selectedSport.sprtId
    }

    if(this.getters.gameBannerId && this.getters.simpleSport == 'N1') {
      bettype = 'G3'
    }
    if(this.getters.hotSchedule) {
      bettype = 'G98'
    }

    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.account.oddsType,
      page: this.getters.selectedPage,
      sorttyp: this.getters.selectedSort,
      token: payload.token,
    }

    //if show league
    // if(this.getters.arr_selectedLeagueList.length > 0) {
    //   data.leagues = this.getters.arr_selectedLeagueList
    //   url = window._baseUrl + '/sport-odds-leagues'
    // }
    if(this.getters.searchLeague.lid>0){
      if (this.getters.account.previewFlag == true) {
        url = window._baseUrl + '/sport-odds-leagues-preview';
      } else {
        url = window._baseUrl + '/sport-odds-leagues'
      }
      data.leagues = [this.getters.searchLeague.lid]
    }else if (this.getters.cookieLeague) {
      var cookieLeague = this.getters.cookieLeague
      if (Object.keys(cookieLeague).length > 0) {
        var selectedMarket = this.getters.selectedMarket
        var selectedSport = this.getters.selectedBettype.sprtId
        var selectedBettype = this.getters.selectedBettype.betTypId

        if (this.getters.isGameBannerSelected) {
          selectedBettype += 'gmBanner'
        }
        if (!this.getters.selectAllLeague) {
          if (cookieLeague[selectedMarket]) {
            if (cookieLeague[selectedMarket][selectedSport]) {
              if (cookieLeague[selectedMarket][selectedSport][selectedBettype] && Object.keys(cookieLeague[selectedMarket][selectedSport][selectedBettype]).length > 0 ) {
                if (this.getters.account.previewFlag == true) {
                  url = window._baseUrl + '/sport-odds-leagues-preview';
                } else {
                  url = window._baseUrl + '/sport-odds-leagues'
                }
                data.leagues = cookieLeague[selectedMarket][selectedSport][selectedBettype]
              } else {
                if (this.getters.account.previewFlag == true) {
                  url = window._baseUrl + '/sport-odds-preview'
                } else {
                  url = window._baseUrl + '/sport-odds'
                }
              }
            } else {
              if (this.getters.account.previewFlag == true) {
                url = window._baseUrl + '/sport-odds-preview'
              } else {
                url = window._baseUrl + '/sport-odds'
              }
            }
          } else {
            if (this.getters.account.previewFlag == true) {
              url = window._baseUrl + '/sport-odds-preview'
            } else {
              url = window._baseUrl + '/sport-odds'
            }
          }
        } else {
          if (this.getters.account.previewFlag == true) {
            url = window._baseUrl + '/sport-odds-preview'
          } else {
            url = window._baseUrl + '/sport-odds'
          }
        }
      }
    }

    //if is show fav events
    if (payload.showfavorite != undefined) {
      this.commit('SPORT_SHOW_FAV_EVENTS', payload.showfavorite)
    } else {

    }
    // if(this.getters.showFavEvents && this.getters.favouriteEvents[this.getters.selectedMarket] && this.getters.favouriteEvents[this.getters.selectedMarket][this.getters.selectedBettype.sprtId]) {
    if (this.getters.showFavEvents) {
      _.unset(data, 'leagues')
      // data.events = this.getters.favouriteEvents[this.getters.selectedMarket][this.getters.selectedBettype.sprtId]
      if (this.getters.favouriteEvents[this.getters.selectedBettype.sprtId] && Object.keys(this.getters.favouriteEvents[this.getters.selectedBettype.sprtId]).length > 0) {
        // if isGameBannerSelected true, filter the events
        if(this.getters.isGameBannerSelected && (this.getters.eventList.length > 0 || this.getters.sortedRBEventList.length > 0)) {
          var favEvents = this.getters.favouriteEvents[this.getters.selectedBettype.sprtId]
          // var eventsList = this.getters.eventList.length > 0? this.getters.eventList:this.getters.sortedRBEventList
          var eventsList = this.getters.eventList.concat(this.getters.sortedRBEventList)
          var favEventsTemp = []
          var found = false
          _.forEach(favEvents, function (feveid, key) {
            found = false
            _.forEach(eventsList, function (eventObj, eventObjKey) {
              _.forEach(eventObj, function (event, eventKey) {
                if(event.eveid == feveid) {
                  favEventsTemp.push(feveid)
                  found = true
                  return false
                }
              });
              if(found) {
                return false
              }
            });
          });
          // console.log(favEventsTemp)
          if(favEventsTemp.length > 0){
            data.events = favEventsTemp
          } else {
            data.events = '0'
          }

        } else {
          data.events = this.getters.favouriteEvents[this.getters.selectedBettype.sprtId]
        }
      } else {
        data.events = '0' //no event sel
      }
      if (this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId] && Object.keys(this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId]).length > 0) {
        data.lgevents = this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId]
      } else {
        data.lgevents = '0' //no event sel
      }

      if(this.getters.account.previewFlag == true){
          url = window._baseUrl + '/sport-odds-favevents-preview'
        }else{
          url = window._baseUrl + '/sport-odds-favevents'
        }

      if (data.token == undefined) {
        data.token = window.token.arr_7;
      }
      data.showFav = '1'
    }
    //if is parlay show euro odds
    if (plytype == '5' && this.getters.account.oddsType != 'am') {
      data.odd = this.getters.oddTypesList.EU.key
    }

    if (payload.sDate != null) {
      data.date = payload.sDate;
    } else {
      data.date = schedule == this.getters.market.earlyMarket.key ? this.getters.selectedEarlyParlayDate : '0'
      if (plytype == '5') {
        data.date = this.getters.selectedEarlyParlayDate
      }
    }
    //default for inplay and today
    data.plytypgrp = plytype
    if (plytype == '7' ||
      plytype == '8' ||
      plytype == '9' ||
      plytype == '10') {
      data.plytypgrp = '1'
    }

    // if (data.plytypgrp == '2' && this.getters.int_fullHalfTime == '2') {
    //   data.plytypgrp = '6'
    // } else 
    // if (data.plytypgrp == '3' && this.getters.int_fullHalfTime == '2') {
    //   data.plytypgrp = '7'
    // }

    //ob
    if(data.plytypgrp == '2'){  //soccer CS tmp
      data.plytypgrp = '12'
    }else if(data.plytypgrp == '3'){  //soccer TG
      data.plytypgrp = '13'
    }

    if (state.isGameBannerSelected) {
      data.gameMenuId = this.getters.gameBannerId
    } else {
      data.gameMenuId = 0;
    }

    //cdn checking
    if (url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      url += '/' + data.schedule
      httpMethod = 'get'
      delete data.schedule
    }

    core.$ajax({
      method: httpMethod,
      url: url,
      data: data,
    }).done(((res) => {
      var events = _.cloneDeep(res.events)
      var rbevents = _.cloneDeep(res.rbevents)

      if (payload.schedule == this.getters.market.inPlayMarket.key) {
        rbevents = _.cloneDeep(res.events)
      }
      this.commit('IS_CHANGE_TEMPLATE', false)
      //if forecast selected refresh score
      if (this.getters.sportForecastSelectedEvent && this.getters.sportForecastSelectedEvent.rbinfo) {
        var isEventFound = _.find(_.flatMap(res.events), { eveid: this.getters.sportForecastSelectedEvent.eveid })
        if (isEventFound && isEventFound.rbinfo) {
          var selectedForecast = this.getters.sportForecastSelectedEvent
          if (selectedForecast.rbinfo.scoa != isEventFound.rbinfo.scoa
            || selectedForecast.rbinfo.scob != isEventFound.rbinfo.scob) {
            selectedForecast.rbinfo.scoa = isEventFound.rbinfo.scoa
            selectedForecast.rbinfo.scob = isEventFound.rbinfo.scob
            EventBus.$emit('FORECAST_GETWAITINGLIST', 'nodata')
            this.commit('SPORTFORECAST_SELECTEDEVENT', selectedForecast)
          }
        }
      }
      if(res.earlyParlayDateList){
        this.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
      }
      //if(this.getters.arr_selectedLeagueList.length == 0)
      this.commit('TOTALPAGE', res.ttlPg)
      if (this.getters.selectedPage > res.ttlPg) {
        this.commit('SELECTED_PAGE', res.ttlPg)
      }
      //alert(payload.scheduleMarket+'dddd'+this.getters.market.inPlayMarket.key)
      if(schedule== this.getters.market.inPlayMarket.key){
        this.commit('FAVOURITERBEVENTCOUNT', 0)
      }
      if (payload.scheduleMarket == this.getters.market.inPlayMarket.key) {
        this.commit('RBEVENTLIST', _.cloneDeep(res.events))
        this.dispatch('sortRBEvents')
      }else {
        if(!payload.showfavorite && !this.getters.showFavEvents) {
          this.commit('EVENTLIST', events)
        }
      }
      if (payload.showfavorite && this.getters.showFavEvents) {
        this.commit('FAVOURITERBEVENTCOUNT', 0)
        this.commit('FAVOURITEEVENTCOUNT', 0)
        var rbeventsTemp = rbevents
          // if(rbevents && rbevents.length > 0){
          //   var rbeventsTemp = []
          //   var rbeCount = 0
          //   _.forEach(rbevents, ((event, skey) => {
          //     _.forEach(event, ((data, key) => {
          //       if(data.all > 0) {
          //         if(!rbeventsTemp[rbeCount]) {
          //           rbeventsTemp[rbeCount] = []
          //         }
          //         rbeventsTemp[rbeCount].push(data)
          //       }
          //     }))
          //     if(rbeventsTemp[rbeCount]) {
          //       rbeCount++
          //     }
          //   }))
          // }
          if(events && events.length > 0) {
            var DateNow = new moment().utcOffset("-04:00").format("YYYY-MM-DD")
            var eventsTemp = []
            var eCount = 0
            _.forEach(events, ((event, skey) => {
              _.forEach(event, ((data, key) => {
                if(data.dt) {
                  if((this.getters.selectedMarket == this.getters.market.tdyMarket.key || this.getters.selectedMarket == this.getters.market.hotSportMarket.key) && DateNow == new moment(data.dt).format("YYYY-MM-DD")) {
                    if(!eventsTemp[eCount]) {
                      eventsTemp[eCount] = []
                    }
                    eventsTemp[eCount].push(data)
                  } else if(this.getters.selectedMarket == this.getters.market.earlyMarket.key && DateNow != new moment(data.dt).format("YYYY-MM-DD")) {
                    if(!eventsTemp[eCount]) {
                      eventsTemp[eCount] = []
                    }
                    eventsTemp[eCount].push(data)
                  }
                }
              }))
              if(eventsTemp[eCount]) {
                eCount++
              }
            }))
          }
          if (payload.scheduleMarket == this.getters.market.inPlayMarket.key) {
            this.commit('RBEVENTLIST', (rbeventsTemp && rbeventsTemp.length > 0)? rbeventsTemp:eventsTemp)
            this.dispatch('sortRBEvents')
          } else {
            if(schedule==this.getters.market.inPlayMarket.key){
              if(rbeventsTemp && rbeventsTemp.length >0) {
                this.commit('EVENTLIST', rbeventsTemp)
                this.commit('RBEVENTLIST', rbeventsTemp)
                this.dispatch('sortRBEvents')
              } else {
                EventBus.$emit('changemain', true)
              }
            } else if(schedule==this.getters.market.hotSportMarket.key){
              if((rbeventsTemp && rbeventsTemp.length >0) || (eventsTemp && eventsTemp.length >0)) {
                this.commit('EVENTLIST', eventsTemp)
                this.commit('RBEVENTLIST', rbeventsTemp)
                this.dispatch('sortEvents')
                this.dispatch('sortRBEvents')
              } else {
                EventBus.$emit('changemain', true)
              }
            }else {
              if((rbeventsTemp && rbeventsTemp.length >0) || (eventsTemp && eventsTemp.length >0)) {
                this.commit('EVENTLIST', eventsTemp)
                this.commit('RBEVENTLIST', rbeventsTemp)
                this.dispatch('sortRBEvents')
              } else {
                EventBus.$emit('changemain', true)
              }
            }
          }
      }

      //Inplay common/today/early, !today rb (prevent today rb run)
      if(this.getters.open_RBMarket || (payload.scheduleMarket!=this.getters.market.inPlayMarket.key && payload.scheduleMarket!=this.getters.market.hotSportMarket.key)){
        if(this.getters.selectedMarket==this.getters.market.earlyMarket.key || (this.getters.selectedBettype.betTypId == '5' && this.getters.isParlayTab)) {
          state.updateRightBoardToggle = true
        }
        this.dispatch('sortEvents')
      }
      
      window.STORE = this
      if (payload.callback) {
        return payload.callback(res)
      }
    }).bind(this)).catch(((errRes) => {
      if (payload.callback) {
        return payload.callback(errRes)
      }
    }).bind(this))
  },
  getRbTodayOdds(context, payload) {
    payload = payload ? payload : {}

    var url = ''

    if (this.getters.account.previewFlag == true) {
      url = window._baseUrl + '/sport-odds-preview'
    } else {
      url = window._baseUrl + '/sport-odds'
    }

    var httpMethod = 'post'
    var bettype = '';
    var plytype = '';
    var schedule = 4;
    
    if (payload.sportId != null) {
      bettype = payload.sportId;
      plytype = "1";
    } else {
      bettype = this.getters.selectedBettype.sprtId
      plytype = this.getters.selectedBettype.betTypId
      if(this.getters.selectedBettype.betTypId == '5' && !this.getters.isParlayTab){
        plytype = this.getters.previousBettype && this.getters.previousBettype.bettype? this.getters.previousBettype.bettype.betTypId:'1'
      }
    }

    if(this.getters.gameBannerId && this.getters.simpleSport == 'N1') {
      bettype = 'G3'
    }

    if(this.getters.hotSchedule){
      schedule = this.getters.market.hotSportMarket.key
      bettype = this.getters.selectedSport.sprtId
    }
    
    
    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.account.oddsType,
      page: this.getters.selectedPage,
      sorttyp: this.getters.selectedSort,
      token: payload.token,
    }

    if(this.getters.searchLeague.lid>0){
      if (this.getters.account.previewFlag == true) {
        url = window._baseUrl + '/sport-odds-leagues-preview';
      } else {
        url = window._baseUrl + '/sport-odds-leagues'
      }
      data.leagues = [this.getters.searchLeague.lid]
    }else if (this.getters.cookieLeague) {
      var cookieLeague = this.getters.cookieLeague
      if (Object.keys(cookieLeague).length > 0) {
        var selectedMarket = this.getters.selectedMarket
        var selectedSport = this.getters.selectedBettype.sprtId
        var selectedBettype = this.getters.selectedBettype.betTypId

        if (this.getters.isGameBannerSelected) {
          selectedBettype += 'gmBanner'
        }
        if (!this.getters.selectAllLeague) {
          if (cookieLeague[selectedMarket]) {
            if (cookieLeague[selectedMarket][selectedSport]) {
              if (cookieLeague[selectedMarket][selectedSport][selectedBettype] && Object.keys(cookieLeague[selectedMarket][selectedSport][selectedBettype]).length > 0 ) {
                if (this.getters.account.previewFlag == true) {
                  url = window._baseUrl + '/sport-odds-leagues-preview';
                } else {
                  url = window._baseUrl + '/sport-odds-leagues'
                }
                data.leagues = cookieLeague[selectedMarket][selectedSport][selectedBettype]
              } else {
                if (this.getters.account.previewFlag == true) {
                  url = window._baseUrl + '/sport-odds-preview'
                } else {
                  url = window._baseUrl + '/sport-odds'
                }
              }
            } else {
              if (this.getters.account.previewFlag == true) {
                url = window._baseUrl + '/sport-odds-preview'
              } else {
                url = window._baseUrl + '/sport-odds'
              }
            }
          } else {
            if (this.getters.account.previewFlag == true) {
              url = window._baseUrl + '/sport-odds-preview'
            } else {
              url = window._baseUrl + '/sport-odds'
            }
          }
        } else {
          if (this.getters.account.previewFlag == true) {
            url = window._baseUrl + '/sport-odds-preview'
          } else {
            url = window._baseUrl + '/sport-odds'
          }
        }
      }
    }

    if (payload.sDate != null) {
      data.date = payload.sDate;
    } else {
      data.date = schedule == this.getters.market.earlyMarket.key ? this.getters.selectedEarlyParlayDate : '0'
      if (plytype == '5') {
        data.date = this.getters.selectedEarlyParlayDate
      }
    }
    //default for inplay and today
    data.plytypgrp = plytype
    if (plytype == '7' || plytype == '8' || plytype == '9' || plytype == '10') {
      data.plytypgrp = '1'
    }

    //ob
    if(data.plytypgrp == '2'){  //soccer CS tmp
      data.plytypgrp = '12'
    }else if(data.plytypgrp == '3'){  //soccer TG
      data.plytypgrp = '13'
    }

    if (state.isGameBannerSelected) {
      data.gameMenuId = this.getters.gameBannerId
    } else {
      data.gameMenuId = 0;
    }

    //cdn checking
    if (url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      url += '/' + data.schedule
      httpMethod = 'get'
      delete data.schedule
    }

    //if is parlay show euro odds
    if (plytype == '5' && this.getters.account.oddsType != 'am') {
      data.odd = this.getters.oddTypesList.EU.key
    }

    core.$ajax({
      method: httpMethod,
      url: url,
      data: data,
    }).done(((res) => {
      var events = _.cloneDeep(res.events)
      var rbevents = _.cloneDeep(res.events_rb)

      this.commit('IS_CHANGE_TEMPLATE', false)
      //if forecast selected refresh score
      if (this.getters.sportForecastSelectedEvent && this.getters.sportForecastSelectedEvent.rbinfo) {
        var isEventFound = _.find(_.flatMap(res.events_rb), { eveid: this.getters.sportForecastSelectedEvent.eveid })
        if (isEventFound && isEventFound.rbinfo) {
          var selectedForecast = this.getters.sportForecastSelectedEvent
          if (selectedForecast.rbinfo.scoa != isEventFound.rbinfo.scoa || selectedForecast.rbinfo.scob != isEventFound.rbinfo.scob) {
            selectedForecast.rbinfo.scoa = isEventFound.rbinfo.scoa
            selectedForecast.rbinfo.scob = isEventFound.rbinfo.scob
            EventBus.$emit('FORECAST_GETWAITINGLIST', 'nodata')
            this.commit('SPORTFORECAST_SELECTEDEVENT', selectedForecast)
          }
        }
      }
      if(res.earlyParlayDateList){
        this.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
      }

      this.commit('TOTALPAGE', res.ttlPg)
      if (this.getters.selectedPage > res.ttlPg) {
        this.commit('SELECTED_PAGE', res.ttlPg)
      }

      if(schedule== this.getters.market.inPlayMarket.key){
        this.commit('FAVOURITERBEVENTCOUNT', 0)
      }

      this.commit('RBEVENTLIST', rbevents)
      this.dispatch('sortRBEvents')
      
      this.commit('EVENTLIST', events)
      this.dispatch('sortEvents')
      
      window.STORE = this
      if (payload.callback) {
        return payload.callback(res)
      }
    }).bind(this)).catch(((errRes) => {
      if (payload.callback) {
        return payload.callback(errRes)
      }
    }).bind(this))
  },
  getSportAllBet(context, payload) {
    // if(!payload.inAllBet) {
    //   this.commit('SPORT_MINIBET_TOGGLE', false)
    //   EventBus.$emit('sportTableReloading', true )
    // }
    var eventDate = new moment(payload.event.dt).locale('en').format("YYYY-MM-DD")
    let schedulesSelected = this.getters.selectedMarket;
    if (this.getters.showFavEvents) {
      schedulesSelected = 2;
      // var DateNow = new moment().zone("-04:00").format("YYYY-MM-DD")
      var DateNow = new moment().locale('en').utcOffset("-04:00").format("YYYY-MM-DD")
      if (payload.event.rbinfo || payload.event.rbstatus) {
        schedulesSelected = 3;
      } else if (eventDate == DateNow) {
        schedulesSelected = 1;
      }
    }
    var data = {
      sprtid: this.getters.selectedBettype.sprtId,
      schedule: schedulesSelected,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.account.oddsType,
      evntid: payload.event.eveid,
    }


    var filterDateIndex = _.indexOf(this.getters.earlyParlayDateList, eventDate)
    data.date = filterDateIndex != -1 ? filterDateIndex : 99

    var plytype = this.getters.selectedBettype.betTypId
    //is normal and parlay
    if (plytype == '1' || plytype == '5') {
      data.plytypgrp = plytype
    }
    //if other sport common
    else if (plytype == '7' || plytype == '8' || plytype == '9' || plytype == '10') {
      data.plytypgrp = '1'
    }
    
    if(this.getters.selectedBettype.betTypId == '5' && !this.getters.isParlayTab){
      data.plytypgrp = this.getters.previousBettype && this.getters.previousBettype.bettype? this.getters.previousBettype.bettype.betTypId:'1'
      if (data.plytypgrp == '7' || data.plytypgrp == '8' || data.plytypgrp == '9' || data.plytypgrp == '10') {
        data.plytypgrp = '1'
      }
    }

    if (data.sprtid.indexOf('G') >= 0) {
      data.sprtid = 'N' + payload.event.sptid
    }

    if (this.getters.selectedMarket == '3' || (this.getters.selectedMarket == '1' && plytype != '5')) {
      data.date = 0
    }

    //if is parlay show euro odds
    if (this.getters.selectedBettype.betTypId == '5' && this.getters.account.oddsType != 'am' && this.getters.isParlayTab) {
      data.odd = this.getters.oddTypesList.EU.key
    }
    data.token = payload.token
    core.$ajax({
      method: 'post',
      url: _baseUrl + '/sport-allbet',
      data: data,
    }).done(((res) => {
      if (res.allBet && res.allBet.sp) {
        for (let eveid = 0; eveid < Object.keys(res.allBet.sp).length; eveid++) {
          _.assign(res.allBet.sp[Object.keys(res.allBet.sp)[eveid]], { 'sptid': res.allBet.sptid })
        }
      }
      this.commit('IS_CHANGE_TEMPLATE', false)
      this.commit('EVENT_ALLBET', res.allBet)
      this.commit('MAINMARKET_BET', _.cloneDeep(res.allBet))  //clone to morebet cs
      this.commit('SELECTED_ALLBETNEW', true)
      this.commit('MOREBETLOADING', false)
      if (!payload.inAllBet)
        EventBus.$emit('sportTableReloading', false)
      if (payload.callback) {
        return payload.callback(res)
      }
    }).bind(this)).catch((errRes) => {
      console.log(errRes)
    })
  },
  getMatchAllBet(context, payload) {
    state.previousLeftEvent = payload.event
    if(this.getters.open_RBMarket && this.getters.selectedSport.sprtId == 'G98') {
      if(payload.event.sptid != null && payload.event.sptid != '') {
        let sport = this.getters.sportIdArr[payload.event.sptid]
        let selectedBetType = _.find(this.getters.sportList, function(x){
          return x.sprtId == sport
        })
        if(this.getters.selectedBettype.sprtId != selectedBetType.sprtId) {
          this.commit('SELECTED_BETTYPE', selectedBetType)
        }
      }
    }

    if(this.getters.hotSchedule && this.getters.selectedSport.sprtId == 'G98') {
      if(payload.event.sptid != null && payload.event.sptid != '') {
        let sport = this.getters.sportIdArr[payload.event.sptid]
        let selectedBetType = _.find(this.getters.sportList, function(x){
          return x.sprtId == sport
        })
        if(this.getters.selectedBettype.sprtId != selectedBetType.sprtId) {
          this.commit('SELECTED_BETTYPE', selectedBetType)
        }
      }
    }

    this.commit('ALLBET_RELOADING', true)
    var eventDate = new moment(payload.event.dt).locale('en').format("YYYY-MM-DD")
    // handle RB match at today
    var selMarket = this.getters.selectedMarket
    if(this.getters.selectedBettype.betTypId=='5'){ // parlay 
      selMarket = 2;
      var DateNow = new moment().locale('en').utcOffset("-04:00").format("YYYY-MM-DD")
      if (eventDate == DateNow) {
        selMarket = 1;
      }
    }

    if(this.getters.hotSchedule){
      selMarket = 1;
    }
    if(payload.isRB) {
      selMarket = state.market.inPlayMarket.key
    }

    if(!_.isUndefined(payload.event.eveid)){
      this.commit('SELECTED_EVEID', payload.event.eveid)
    }

    var data = {
      sprtid: this.getters.selectedBettype.sprtId,
      schedule: selMarket,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.account.oddsType,
      evntid: !_.isUndefined(payload.event.eveid) ? payload.event.eveid : this.getters.selectedEventId,
    }
    
    
    var filterDateIndex = _.indexOf(this.getters.earlyParlayDateList, eventDate)
    data.date = filterDateIndex != -1 ? filterDateIndex : 99

    var plytype = this.getters.selectedBettype.betTypId
    //is normal and parlay
    if (plytype == '1' || plytype == '5') {
      data.plytypgrp = plytype
    }
    //if other sport common
    else if (plytype == '7' || plytype == '8' || plytype == '9' || plytype == '10') {
      data.plytypgrp = '1'
    }else{
      data.plytypgrp = '1'
    }
    if(this.getters.selectedBettype.betTypId == '5' && !this.getters.isParlayTab){
      data.plytypgrp = this.getters.previousBettype && this.getters.previousBettype.bettype? this.getters.previousBettype.bettype.betTypId:'1'
      if (data.plytypgrp == '7' || data.plytypgrp == '8' || data.plytypgrp == '9' || data.plytypgrp == '10') {
        data.plytypgrp = '1'
      }
    }
    if(payload.event.sptid){
      data.sprtid = 'N' + payload.event.sptid
    }
    if (data.sprtid.indexOf('G') >= 0) {
      data.sprtid = 'N' + payload.event.sptid
    }
    if(!_.isUndefined(payload.event.filtersptid)){
      data.sprtid = 'N' + payload.event.sptid
    }
    if (this.getters.selectedMarket == '3' || (this.getters.selectedMarket == '1' && plytype != '5') || payload.isRB) {
      data.date = 0
    }

    //if is parlay show euro odds
    if (this.getters.selectedBettype.betTypId == '5' && this.getters.account.oddsType != 'am' && this.getters.isParlayTab) {
      data.odd = this.getters.oddTypesList.EU.key
    }
    data.token = payload.token
    core.$ajax({
      method: 'post',
      url: _baseUrl + '/sport-allbet',
      data: data,
    }).done(((res) => {
      if (res.allBet){  
        res.allBet.rbstatus= (payload.isRB)? 1:0;
      }
      if (res.allBet && res.allBet.sp) {
        for (let eveid = 0; eveid < Object.keys(res.allBet.sp).length; eveid++) {
          _.assign(res.allBet.sp[Object.keys(res.allBet.sp)[eveid]], { 'sptid': res.allBet.sptid ,'rbstatus': res.allBet.rbstatus })
        }
      }
      
      if (res.allBet && res.allBet.eveid == payload.event.eveid) {
        res.allBet.isFavourite = payload.event.isFavourite
      }
      if(payload.loadTemplate!=undefined && (payload.loadTemplate==1 || payload.loadTemplate==2 || payload.loadTemplate==3)){
        // 1 open right score board only, 
        // 2 open live tv, 
        // 3 open right score board + all bet, 
        // 0 all bet only
        if(payload.loadTemplate==1){
          let tvlinkArray={};
          tvlinkArray.link = null
          tvlinkArray.eveid = null
          this.commit('LIVETV', tvlinkArray);
        }
        if(payload.loadTemplate==3 ){
          this.commit('SORTEDMATCHEVENTLIST', res.allBet)
          this.commit('SELECTED_MATCHALLBET', true)
        }
        if(payload.loadTemplate==2 && !payload.notLoadTV){
          core.$ajax({
            url: _baseUrl + '/livetv',
            method: 'post',
            data: {
              chlid: res.allBet.ch,
              eventid: res.allBet.eveid,
              league: res.allBet.lgeid,
              tacap: res.allBet.tacapt,
              tbcap: res.allBet.tbcapt
            }
          }).then(response => {
            let tvlinkArray={};
            tvlinkArray.link = response
            tvlinkArray.eveid = res.allBet.eveid
            this.commit('LIVETV', tvlinkArray);
          })
        }
        if(this.getters.selectedBettype.sprtId == 'N1' && this.getters.selectedBettype.tmpltId == '1' && !this.getters.simpleSport) {
          var spId = this.getters.selectedBettype.sprtId
          var tpltId = this.getters.selectedBettype.tmpltId
          if(!_.isUndefined(this.getters.unfold_AllSc[spId]) && !_.isUndefined(this.getters.unfold_AllSc[spId][tpltId])){
            state.show_Unfold = (!this.getters.unfold_AllSc[spId][tpltId]) ? true : false
            state.show_Fold = (!this.getters.unfold_AllSc[spId][tpltId]) ? false : true
            this.commit('UNFOLD_ALLSC', this.getters.unfold_AllSc[spId][tpltId])
          } else {
            this.commit('UNFOLD_ALLSC', false);
          }
        } else {
          this.commit('UNFOLD_ALLSC', false);
        }
        this.commit('FIRSTEVENT',res.allBet)
        
      }else{
        this.commit('SORTEDMATCHEVENTLIST', res.allBet)
        this.commit('FIRSTEVENT',res.allBet)
        this.commit('SELECTED_MATCHALLBET', true)
      }
      
      this.commit('ALLBET_RELOADING', false)
      this.commit('R_ALLBET_RELOADING', false);
      $('#tblRefresh').removeClass('loading-static-animation')
      EventBus.$emit('activeAllBetOsScoreBoard', event)
      if (!payload.inAllBet)
        // EventBus.$emit('sportTableReloading', false )
        if (payload.callback) {
          return payload.callback(res)
        }
    }).bind(this)).catch((errRes) => {
      console.log(errRes)
    })
  },
  getSpecialEventOdds(context, payload) {
    payload = payload ? payload : {}
    var url = ''
    var httpMethod = 'post'
    var bettype = this.getters.specialEventList['sprtId'];
    var plytype = '1';
    var schedule = this.getters.selectedMarket == '1'? '4':this.getters.selectedMarket;

    if (this.getters.account.previewFlag == true) {
      url = window._baseUrl + '/sport-odds-preview'
    } else {
      url = window._baseUrl + '/sport-odds'
    }

    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.account.oddsType,
      page: this.getters.selectedPage,
      sorttyp: this.getters.selectedSort,
      token: payload.token,
      plytypgrp: plytype,
    }

    // filter leagues
    // if(this.getters.searchLeague.lid>0){
    //   url = window._baseUrl + '/sport-odds-leagues'
    //   data.leagues = [this.getters.searchLeague.lid]
    // }else if (this.getters.cookieLeague && Object.keys(this.getters.cookieLeague).length > 0 && !this.getters.selectAllLeague) {
    //   var cookieLeague = this.getters.cookieLeague
    //   var selectedMarket = this.getters.selectedMarket
    //   var selectedSport = this.getters.selectedBettype.sprtId
    //   var selectedBettype = this.getters.selectedBettype.betTypId
    //   if (cookieLeague[selectedMarket] && cookieLeague[selectedMarket][selectedSport] && cookieLeague[selectedMarket][selectedSport][selectedBettype] && Object.keys(cookieLeague[selectedMarket][selectedSport][selectedBettype]).length > 0 ) {
    //     url = window._baseUrl + '/sport-odds-leagues'
    //     data.leagues = cookieLeague[selectedMarket][selectedSport][selectedBettype]
    //   }
    // }

    // //if is show fav events
    // if (payload.showfavorite != undefined) {
    //   this.commit('SPORT_SHOW_FAV_EVENTS', payload.showfavorite)
    // }
    // if (this.getters.showFavEvents) {
    //   url = window._baseUrl + '/sport-odds-favevents'
    //   _.unset(data, 'leagues')
    //   if (this.getters.favouriteEvents[this.getters.selectedBettype.sprtId] && Object.keys(this.getters.favouriteEvents[this.getters.selectedBettype.sprtId]).length > 0) {
    //     data.events = this.getters.favouriteEvents[this.getters.selectedBettype.sprtId]
    //   } else {
    //     data.events = '0' //no event sel
    //   }
    //   if (this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId] && Object.keys(this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId]).length > 0) {
    //     data.lgevents = this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId]
    //   } else {
    //     data.lgevents = '0' //no event sel
    //   }
    //   if (data.token == undefined) {
    //     data.token = window.token.arr_7;
    //   }
    //   data.showFav = '1'
    // }

    if (payload.sDate != null) {
      data.date = payload.sDate;
    } else {
      this.commit('SELECTEDEARLYPARLAYDATE', '99')
      data.date = schedule == this.getters.market.earlyMarket.key ? this.getters.selectedEarlyParlayDate : '0'
    }

    //cdn checking
    if (url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      url += '/' + data.schedule
      httpMethod = 'get'
      delete data.schedule
    }

    core.$ajax({
      method: httpMethod,
      url: url,
      data: data,
    }).done(((res) => {
      var events = _.cloneDeep(res.events)
      var rbevents = _.cloneDeep(res.rbevents)
      this.commit('IS_CHANGE_TEMPLATE', false)
      //if forecast selected refresh score
      // if (this.getters.sportForecastSelectedEvent && this.getters.sportForecastSelectedEvent.rbinfo) {
      //   var isEventFound = _.find(_.flatMap(res.events), { eveid: this.getters.sportForecastSelectedEvent.eveid })
      //   if (isEventFound && isEventFound.rbinfo) {
      //     var selectedForecast = this.getters.sportForecastSelectedEvent
      //     if (selectedForecast.rbinfo.scoa != isEventFound.rbinfo.scoa
      //       || selectedForecast.rbinfo.scob != isEventFound.rbinfo.scob) {
      //       selectedForecast.rbinfo.scoa = isEventFound.rbinfo.scoa
      //       selectedForecast.rbinfo.scob = isEventFound.rbinfo.scob
      //       EventBus.$emit('FORECAST_GETWAITINGLIST', 'nodata')
      //       this.commit('SPORTFORECAST_SELECTEDEVENT', selectedForecast)
      //     }
      //   }
      // }
      if(res.earlyParlayDateList){
        this.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
      }
      this.commit('TOTALPAGE', res.ttlPg)
      if (this.getters.selectedPage > res.ttlPg) {
        this.commit('SELECTED_PAGE', res.ttlPg)
      }

      // if(rbevents && rbevents.length > 0) {
        this.commit('RBEVENTLIST', rbevents == undefined? []:rbevents)
        this.dispatch('sortRBEvents')
      // }

      // if(events && events.length > 0) {
        this.commit('EVENTLIST', events)
        this.dispatch('sortEvents')
      // }

      // if(schedule== this.getters.market.inPlayMarket.key){
      //   this.commit('FAVOURITERBEVENTCOUNT', 0)
      // }
      // if (payload.scheduleMarket == this.getters.market.inPlayMarket.key) {
      //   this.commit('RBEVENTLIST', _.cloneDeep(res.events))
      //   this.dispatch('sortRBEvents')
      // }else {
      //   if(!payload.showfavorite && !this.getters.showFavEvents) {
      //     this.commit('EVENTLIST', events)
      //   }
      // }
      // if (payload.showfavorite && this.getters.showFavEvents) {
      //   this.commit('FAVOURITERBEVENTCOUNT', 0)
      //   this.commit('FAVOURITEEVENTCOUNT', 0)
      //   var rbeventsTemp = rbevents
      //   if(events && events.length > 0) {
      //     var DateNow = new moment().utcOffset("-04:00").format("YYYY-MM-DD")
      //     var eventsTemp = []
      //     var eCount = 0
      //     _.forEach(events, ((event, skey) => {
      //       _.forEach(event, ((data, key) => {
      //         if(data.dt) {
      //           if((this.getters.selectedMarket == this.getters.market.tdyMarket.key || this.getters.selectedMarket == this.getters.market.hotSportMarket.key) && DateNow == new moment(data.dt).format("YYYY-MM-DD")) {
      //             if(!eventsTemp[eCount]) {
      //               eventsTemp[eCount] = []
      //             }
      //             eventsTemp[eCount].push(data)
      //           } else if(this.getters.selectedMarket == this.getters.market.earlyMarket.key && DateNow != new moment(data.dt).format("YYYY-MM-DD")) {
      //             if(!eventsTemp[eCount]) {
      //               eventsTemp[eCount] = []
      //             }
      //             eventsTemp[eCount].push(data)
      //           }
      //         }
      //       }))
      //       if(eventsTemp[eCount]) {
      //         eCount++
      //       }
      //     }))
      //   }
      //   if (payload.scheduleMarket == this.getters.market.inPlayMarket.key) {
      //     this.commit('RBEVENTLIST', (rbeventsTemp && rbeventsTemp.length > 0)? rbeventsTemp:eventsTemp)
      //     this.dispatch('sortRBEvents')
      //   } else {
      //     if(schedule==this.getters.market.inPlayMarket.key){
      //       if(rbeventsTemp && rbeventsTemp.length >0) {
      //         this.commit('EVENTLIST', rbeventsTemp)
      //         this.commit('RBEVENTLIST', rbeventsTemp)
      //         this.dispatch('sortRBEvents')
      //       } else {
      //         EventBus.$emit('changemain', true)
      //       }
      //     }else {
      //       if((rbeventsTemp && rbeventsTemp.length >0) || (eventsTemp && eventsTemp.length >0)) {
      //         this.commit('EVENTLIST', eventsTemp)
      //         this.commit('RBEVENTLIST', rbeventsTemp)
      //         this.dispatch('sortRBEvents')
      //       } else {
      //         EventBus.$emit('changemain', true)
      //       }
      //     }
      //   }
      // }

      // //Inplay common/today/early, !today rb (prevent today rb run)
      // if(this.getters.open_RBMarket || (payload.scheduleMarket!=this.getters.market.inPlayMarket.key && payload.scheduleMarket!=this.getters.market.hotSportMarket.key)){
      //   if(this.getters.selectedMarket==this.getters.market.earlyMarket.key || (this.getters.selectedBettype.betTypId == '5' && this.getters.isParlayTab)) {
      //     state.updateRightBoardToggle = true
      //   }
      //   this.dispatch('sortEvents')
      // }
      
      window.STORE = this
      if (payload.callback) {
        return payload.callback(res)
      }
    }).bind(this)).catch(((errRes) => {
      if (payload.callback) {
        return payload.callback(errRes)
      }
    }).bind(this))
  },
  sortEvents() {
    var EventsList = _.cloneDeep(this.getters.eventList)
    var sortedEvents = []
    var lgeArr = _.cloneDeep(this.getters.showLgeEve)
    var countx = 0
    var VUE = this
    
    //Handle show total event today/early else collapse league tab
    if(this.getters.selectedMarket != state.market.inPlayMarket.key && this.getters.selectedMarket != state.market.hotSportMarket.key){
      _.forEach(EventsList, function (dtx, key) {
        lgeArr[key] = (_.isUndefined(lgeArr[key])) ? {} : lgeArr[key]
        _.forEach(dtx, function (value, index) {
          if(_.isUndefined(lgeArr[key].hide)){
            lgeArr[key].hide = (countx < window.maxDisplayEvent) ? false : true
          }
          countx++
        });
      });
      sortedEvents = EventsList
      this.commit('SHOW_LGEEVE', lgeArr)
      // this.commit('SORTEDEVENTLIST', sortedEvents)

    } else if (this.getters.selectedMarket == state.market.inPlayMarket.key || this.getters.selectedMarket == state.market.hotSportMarket.key){
      //In-Play common, assign event into sport id key & show sport/lge arr
      var newEveArr = {}
      _.forEach(EventsList, function (evedata, key) {
        var sprtID = (!_.isUndefined(VUE.getters.sportIdArr[evedata[0].sptid])) ? VUE.getters.sportIdArr[evedata[0].sptid] : VUE.getters.sportIdArr['99']
      
        if(!_.isUndefined(newEveArr[sprtID])){
          newEveArr[sprtID][key] = evedata
          // newEveArr[sprtID].push(evedata)
        }else{
          newEveArr[sprtID] = {}
          newEveArr[sprtID][key] = evedata
        }
        
        lgeArr[sprtID] = (_.isUndefined(lgeArr[sprtID])) ? {} : lgeArr[sprtID]
        lgeArr[sprtID][key] = (_.isUndefined(lgeArr[sprtID][key])) ? {} : lgeArr[sprtID][key]
        lgeArr[sprtID].hide = (_.isUndefined(lgeArr[sprtID].hide)) ? false : lgeArr[sprtID].hide

        _.forEach(evedata, function (value, index) {
          if(_.isUndefined(lgeArr[sprtID][key].hide)){
            lgeArr[sprtID][key].hide = (countx < window.maxDisplayEvent) ? false : true
          }
          countx++
        });
      })

      sortedEvents = newEveArr
      this.commit('SHOW_LGEEVE', lgeArr)
    }
    this.commit('SORTEDEVENTLIST', sortedEvents)
    // this.commit('SORTEDEVENTLIST', _.cloneDeep(sortedEvents))

    if (this.getters.showFavEvents && this.getters.selectedMarket != state.market.hotSportMarket.key) {
      var sortedFavRbEvents = _.cloneDeep(this.getters.rbeventList)
      this.commit('SORTEDRBEVENTLIST', _.cloneDeep(sortedFavRbEvents))
      // var sortedFavRbEvents = _.cloneDeep(this.getters.favrbeventList)
      // this.commit('SORTEDFAVRBEVENTLIST', _.cloneDeep(sortedFavRbEvents))
    }
    
    // if (state.selectedMarket==3  && this.getters.favouriteLgeEvents && Object.keys(this.getters.favouriteLgeEvents).length > 0 ) {
    if (this.getters.favouriteLgeEvents && Object.keys(this.getters.favouriteLgeEvents).length > 0 ) {
      this.commit('FAVOURITEEVENTCOUNT', 0)
      this.dispatch('sortFavouriteEvents', {
        orderedEvents: state.sortedEventList,
        callback: ((res) => {
          this.commit('SORTEDEVENTLIST', _.cloneDeep(res))
        })
      })
      // if (state.sortedFavRbEventList) {
      if (state.sortedRBEventList && state.sortedRBEventList.length>0 && state.selectedMarket!=3) {
        this.commit('FAVOURITERBEVENTCOUNT', 0)
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedRBEventList,
          // favEve:state.selectedMarket==3 ? 0: 1,
          callback: ((res) => {
            // this.commit('SORTEDFAVRBEVENTLIST', _.cloneDeep(res))
            this.commit('SORTEDRBEVENTLIST', _.cloneDeep(res))
          })
        })
      }
    }else if (this.getters.favouriteEvents && Object.keys(this.getters.favouriteEvents).length > 0 ) {
      this.commit('FAVOURITEEVENTCOUNT', 0)
      this.dispatch('sortFavouriteEvents', {
        orderedEvents: state.sortedEventList,
        callback: ((res) => {
          this.commit('SORTEDEVENTLIST', _.cloneDeep(res))
        })
      })

      if (state.sortedRBEventList && state.sortedRBEventList.length > 0 && state.selectedMarket!=3) {
        this.commit('FAVOURITERBEVENTCOUNT', 0)
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedRBEventList,
          // favEve:state.selectedMarket==3 ? 0: 1,
          callback: ((res) => {
            this.commit('SORTEDRBEVENTLIST', _.cloneDeep(res))
          })
        })
      }
    }

    var CheckSortedRBEvents = _.cloneDeep(this.getters.rbeventList)
    var CheckSortedEvents = sortedEvents;
    if (this.getters.showFavEvents) {
      state.updateRightBoardToggle = true
      CheckSortedRBEvents = sortedFavRbEvents
      CheckSortedEvents = state.sortedEventList;
    }
    if(this.getters.selectedMarket == state.market.inPlayMarket.key){
      var CheckSortedEvents = sortedEvents
      let firstKey = null;
      if (CheckSortedEvents !== null && CheckSortedEvents !== undefined) {
          for (const key in CheckSortedEvents) { 
            if (CheckSortedEvents.hasOwnProperty(key)) {
              firstKey = key;
              break;
            }
          }
          if (firstKey !== null) {
            var checkLeftEvent = CheckSortedEvents[firstKey][0][0];
          }
      }
      var getSprtId = this.getters.selectedSport.sprtId;
      if (checkLeftEvent && typeof checkLeftEvent === 'object') {
        if(Object.keys(checkLeftEvent).length>0 ){
          var changeRightScoreBoard= true;
          if(Object.keys(state.firstEvent).length>0){
            if(this.getters.eventList.length==0){
              this.commit('FIRSTEVENT', [])
            }
            if(this.getters.selectedMarket == state.market.inPlayMarket.key && changeRightScoreBoard==true ){
              _.forEach(CheckSortedEvents, function (sport_list, key) {
                _.forEach(sport_list, function (league_list, league_value) {
                _.forEach(league_list, function (value, index) {
                  if(value.eveid==state.firstEvent.eveid && getSprtId != 'G98' && state.firstEvent.eveid!=checkLeftEvent.eveid){
                    // changeRightScoreBoard= false;
                    checkLeftEvent = value;
                  }else if(value.eveid==state.firstEvent.eveid && getSprtId == 'G98'){
                    // changeRightScoreBoard= false;
                    checkLeftEvent = value;
                  }
                });
              });
              })
            }
          }
          if(this.getters.livetv.eveid > 0 && this.getters.livetv.link != '' 
            && (this.getters.previousLeftEvent.length > 0 || Object.keys(this.getters.previousLeftEvent).length > 0) 
            && checkLeftEvent.eveid != this.getters.livetv.eveid 
            && this.getters.previousLeftEvent.eveid == this.getters.livetv.eveid) {
              checkLeftEvent = this.getters.previousLeftEvent
          }
          //need this to get firstevent when from today to inplayAllSport
          let inplayAll = (state.show_Unfold === false) && (state.firstEvent.sptid !== 1);
          if(changeRightScoreBoard==true && !this.getters.liveAllBet && (checkLeftEvent.sptid!=1 || state.show_Unfold==true  || state.miniNormal || inplayAll || this.getters.simpleSport)){
            this.dispatch('getMatchAllBet', {
              event: checkLeftEvent,
              isRB:  this.getters.selectedMarket == state.market.inPlayMarket.key?true:false,
              token: token.arr_8,
              loadTemplate: (this.getters.livetv.link!='' && this.getters.livetv.eveid>0 && this.getters.livetv.eveid==checkLeftEvent.eveid)? 2:1,  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
              notLoadTV: (this.getters.livetv.link!='' && this.getters.livetv.eveid>0 && this.getters.livetv.eveid==checkLeftEvent.eveid)? true:false 
            });
          }
        }
      } else {
        this.commit('FIRSTEVENT', [])
      }
    }else {
      if(state.updateRightBoardToggle) {
        if(((CheckSortedRBEvents && CheckSortedRBEvents.length>0) || (CheckSortedEvents && CheckSortedEvents.length>0)) && !this.getters.selectedMatchAllBet) {
          var checkLeftEvent = CheckSortedRBEvents && CheckSortedRBEvents.length>0? CheckSortedRBEvents[0][0]:CheckSortedEvents[0][0];
          // if(CheckSortedRBEvents && CheckSortedRBEvents.length==0){
            var changeRightScoreBoard= true;
            if(Object.keys(state.firstEvent).length>0 && state.firstEvent.eveid!=checkLeftEvent.eveid){
              // if(this.getters.eventList.length==0 && this.getters.rbeventList.length==0){
              //   this.commit('FIRSTEVENT', [])
              // }else{
                _.forEach(CheckSortedRBEvents, function (league_list, key) {
                  _.forEach(league_list, function (value, index) {
                    if(value.eveid==state.firstEvent.eveid){
                      changeRightScoreBoard= false;
                      checkLeftEvent = value
                    }
                  });
                });
                if(changeRightScoreBoard==true){
                  _.forEach(CheckSortedEvents, function (league_list, key) {
                    _.forEach(league_list, function (value, index) {
                      if(value.eveid==state.firstEvent.eveid){
                        // changeRightScoreBoard= false;
                        checkLeftEvent = value
                      }
                    });
                  });
                }
              // }
            }
            if(this.getters.livetv.eveid > 0 && this.getters.livetv.link != '' 
              && (this.getters.previousLeftEvent.length > 0 || Object.keys(this.getters.previousLeftEvent).length > 0) 
              && checkLeftEvent.eveid != this.getters.livetv.eveid 
              && this.getters.previousLeftEvent.eveid == this.getters.livetv.eveid) {
                checkLeftEvent = this.getters.previousLeftEvent
            }
            // if(changeRightScoreBoard==true && (checkLeftEvent.sptid!=1 ||state.show_Unfold==true || state.miniNormal || this.getters.simpleSport)){
            if((checkLeftEvent.sptid!=1 ||state.show_Unfold==true || state.miniNormal || this.getters.simpleSport)){
              this.dispatch('getMatchAllBet', {
                event: checkLeftEvent,
                isRB:  checkLeftEvent.rbstatus && checkLeftEvent.rb? true:false,
                token: token.arr_8,
                loadTemplate: (this.getters.livetv.link!='' && this.getters.livetv.eveid>0 && this.getters.livetv.eveid==checkLeftEvent.eveid)? 2:1,  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
                notLoadTV: (this.getters.livetv.link!='' && this.getters.livetv.eveid>0 && this.getters.livetv.eveid==checkLeftEvent.eveid)? true:false 
              })
            }
          // }
        }else {
          // this.commit('FIRSTEVENT', [])
        }
      } 
      state.updateRightBoardToggle = !state.updateRightBoardToggle
    }
  },
  sortRBEvents() {
    var sortedRBEvents = _.cloneDeep(this.getters.rbeventList)
    
    //Handle show total event on RB else collapse league tab
    var countx = 0
    var rblgeArr = _.cloneDeep(this.getters.showRBLgeEve)
    _.forEach(sortedRBEvents, function (dtx, key) {
      rblgeArr[key] = (_.isUndefined(rblgeArr[key])) ? {} : rblgeArr[key]
      _.forEach(dtx, function (value, index) {
        if(_.isUndefined(rblgeArr[key].hide)){
          rblgeArr[key].hide = (countx < window.maxDisplayEvent) ? false : true
        }
        countx++
      });
    });
    this.commit('SHOW_RBLGEEVE', rblgeArr)
    this.commit('SORTEDRBEVENTLIST', _.cloneDeep(sortedRBEvents))
    
    if (this.getters.showFavEvents) {
      var sortedFavRbEvents = _.cloneDeep(this.getters.favrbeventList)
      this.commit('SORTEDFAVRBEVENTLIST', _.cloneDeep(sortedFavRbEvents))
    }

    // if (this.getters.favouriteEvents || Object.keys(this.getters.favouriteEvents).length > 0) {
    if (this.getters.favouriteLgeEvents && Object.keys(this.getters.favouriteLgeEvents).length > 0) {
      this.commit('FAVOURITERBEVENTCOUNT', 0)
      this.dispatch('sortFavouriteEvents', {
        orderedEvents:state.sortedRBEventList,
        callback: ((res) => {
          this.commit('SORTEDRBEVENTLIST', _.cloneDeep(res))
        })
      })

      // if (state.sortedFavRbEventList) {
      if (state.sortedEventList && state.sortedEventList.length > 0) {
        this.commit('FAVOURITEEVENTCOUNT', 0)
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedEventList,
          // favEve:1,
          callback: ((res) => {
            // this.commit('SORTEDFAVRBEVENTLIST', _.cloneDeep(res))
            this.commit('SORTEDEVENTLIST', _.cloneDeep(res))
          })
        })
      }
    } else if (this.getters.favouriteEvents && Object.keys(this.getters.favouriteEvents).length > 0) {
      this.commit('FAVOURITERBEVENTCOUNT', 0)
      this.dispatch('sortFavouriteEvents', {
        orderedEvents:state.sortedRBEventList,
        callback: ((res) => {
          this.commit('SORTEDRBEVENTLIST', _.cloneDeep(res))
        })
      })

      if (state.sortedEventList && state.sortedEventList.length > 0) {
        this.commit('FAVOURITEEVENTCOUNT', 0)
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedEventList,
          // favEve:1,
          callback: ((res) => {
            // this.commit('SORTEDFAVRBEVENTLIST', _.cloneDeep(res))
            this.commit('SORTEDEVENTLIST', _.cloneDeep(res))
          })
        })
      }
    }

    if(state.updateRightBoardToggle) {
      var CheckSortedRBEvents = sortedRBEvents
      var CheckSortedEvents = _.cloneDeep(this.getters.eventList);
      if (this.getters.showFavEvents) {
        CheckSortedRBEvents = sortedFavRbEvents
        CheckSortedEvents = state.sortedEventList;
      }
      if(((CheckSortedRBEvents && CheckSortedRBEvents.length>0) || (CheckSortedEvents && CheckSortedEvents.length>0)) && !this.getters.selectedMatchAllBet){
        var checkLeftEvent= CheckSortedRBEvents && CheckSortedRBEvents.length>0? CheckSortedRBEvents[0][0]:CheckSortedEvents[0][0];
        var changeRightScoreBoard= true;
       
        if(Object.keys(state.firstEvent).length>0 && state.firstEvent.eveid!=checkLeftEvent.eveid){
          // if(this.getters.eventList.length==0 && this.getters.rbeventList.length==0){
          //   this.commit('FIRSTEVENT', [])
          // }else{
            _.forEach(CheckSortedRBEvents, function (league_list, key) {
              _.forEach(league_list, function (value, index) {
                if(value.eveid==state.firstEvent.eveid){
                  changeRightScoreBoard= false;
                  checkLeftEvent = value
                }
              });
            });
            if(changeRightScoreBoard==true){
              _.forEach(CheckSortedEvents, function (league_list, key) {
                _.forEach(league_list, function (value, index) {
                  if(value.eveid==state.firstEvent.eveid){
                    // changeRightScoreBoard= false;
                    checkLeftEvent = value
                  }
                });
              });
            }
          // }
        }
        if(this.getters.livetv.eveid > 0 && this.getters.livetv.link != '' 
          && (this.getters.previousLeftEvent.length > 0 || Object.keys(this.getters.previousLeftEvent).length > 0) 
          && checkLeftEvent.eveid != this.getters.livetv.eveid 
          && this.getters.previousLeftEvent.eveid == this.getters.livetv.eveid) {
            checkLeftEvent = this.getters.previousLeftEvent
        }
        // if(changeRightScoreBoard==true && (checkLeftEvent.sptid!=1 ||state.show_Unfold==true  || state.miniNormal || this.getters.simpleSport) ){
        if((checkLeftEvent.sptid!=1 ||state.show_Unfold==true  || state.miniNormal || this.getters.simpleSport) ){
          //this.commit('FIRSTEVENT', sortedRBEvents[0][0])
          this.dispatch('getMatchAllBet', {
            event: checkLeftEvent,
            isRB:  checkLeftEvent.rbstatus && checkLeftEvent.rb? true:false,
            token: token.arr_8,
            loadTemplate: (this.getters.livetv.link!='' && this.getters.livetv.eveid>0 && this.getters.livetv.eveid==checkLeftEvent.eveid)? 2:1,  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
            notLoadTV: (this.getters.livetv.link!='' && this.getters.livetv.eveid>0 && this.getters.livetv.eveid==checkLeftEvent.eveid)? true:false 
          })
        }
      } else {
        // this.commit('FIRSTEVENT', [])
      }
    }
    if (this.getters.selectedMarket == state.market.hotSportMarket.key){
      
      if(Object.keys(state.sortedRBEventList).length>0){

        var sortedRBEventList = _.cloneDeep(state.sortedRBEventList)
        var sortedRBEvents = []
        var RBlgeArr = _.cloneDeep(this.getters.showLgeEve)
        var RBcountx = 0
        let VUE = this;
        //In-Play common, assign event into sport id key & show sport/lge arr
        var newEveArr = {}
        _.forEach(sortedRBEventList, function (evedata, key) {
          var sprtID = (!_.isUndefined(VUE.getters.sportIdArr[evedata[0].sptid])) ? VUE.getters.sportIdArr[evedata[0].sptid] : VUE.getters.sportIdArr['99']
        
          if(!_.isUndefined(newEveArr[sprtID])){
            newEveArr[sprtID][key] = evedata
            // newEveArr[sprtID].push(evedata)
          }else{
            newEveArr[sprtID] = {}
            newEveArr[sprtID][key] = evedata
          }
          
          RBlgeArr[sprtID] = (_.isUndefined(RBlgeArr[sprtID])) ? {} : RBlgeArr[sprtID]
          RBlgeArr[sprtID][key] = (_.isUndefined(RBlgeArr[sprtID][key])) ? {} : RBlgeArr[sprtID][key]
          RBlgeArr[sprtID].hide = (_.isUndefined(RBlgeArr[sprtID].hide)) ? false : RBlgeArr[sprtID].hide

          _.forEach(evedata, function (value, index) {
            if(_.isUndefined(RBlgeArr[sprtID][key].hide)){
              RBlgeArr[sprtID][key].hide = (RBcountx < window.maxDisplayEvent) ? false : true
            }
            RBcountx++
          });
        })
        sortedRBEvents = newEveArr
        this.commit('SORTEDRBEVENTLIST', sortedRBEvents)
        this.commit('SHOW_RBLGEEVE', RBlgeArr)
      }
    }
    state.updateRightBoardToggle = !state.updateRightBoardToggle
   
  },
  advancedSortedEventsByTime(orderedEvents, payload) {
    for (var currentEventCount = 0; currentEventCount <= Object.keys(payload.orderedEvents).length - 1; currentEventCount++) {
      if (Object.keys(payload.orderedEvents)[currentEventCount + 1]) {
        var nextEventCount = Object.keys(payload.orderedEvents)[currentEventCount + 1]
        //if next event is same as current event, copy to current
        if (payload.orderedEvents[nextEventCount].lgeid == payload.orderedEvents[currentEventCount].lgeid) {
          //check if current is moveToTop then move next event till the previous event pushed
          if (!payload.orderedEvents[currentEventCount].moveToTop) {
            payload.orderedEvents[currentEventCount] = payload.orderedEvents[currentEventCount].concat(_.cloneDeep(payload.orderedEvents[nextEventCount]))
            payload.orderedEvents[nextEventCount].moveToTop = true
          } else {
            for (var prevEventCount = currentEventCount - 1; prevEventCount >= 0; prevEventCount--) {
              if (!payload.orderedEvents[prevEventCount].moveToTop && !payload.orderedEvents[nextEventCount].moveToTop) {
                payload.orderedEvents[prevEventCount] = payload.orderedEvents[prevEventCount].concat(_.cloneDeep(payload.orderedEvents[nextEventCount]))
                payload.orderedEvents[nextEventCount].moveToTop = true
              }
            }
          }
        }
      }
    }
    payload.orderedEvents = _.reject(payload.orderedEvents, { 'moveToTop': true })
    return payload.callback(payload.orderedEvents)
  },
  setFavLgeEvent(context, payload) {
    let VUE = this
    function recursiveMethod(value, type, league) {
      var selectedMarket = VUE.getters.selectedMarket
      var selectedSport = VUE.getters.selectedBettype.sprtId

      if (value == null && type == 'market') {
        value = {}
        return recursiveMethod(value, 'sport', league)
      }

      if (value == null && type == 'sport') {
        value[selectedSport] = {}
        return recursiveMethod(value[selectedSport], 'bettyp', league)
      }
      else {
        if (value == null) {
          return recursiveMethod(value, 'market', league)
        }
        if (value[selectedSport] == null) {
          value[selectedSport] = []
          value[selectedSport].push(league)
          return value
        }
        value[selectedSport].push(league)
        return value;
      }
    }

    _.forEach(payload.orderedEvents, ((events, key) => {
      _.forEach(events, ((event, key) => {
        if (!_.isUndefined(state.favouriteLgeEvents)) {
          if (_.indexOf(state.favouriteLgeEvents[state.selectedBettype.sprtId], event.lgeid) == 0) {
            if (Object.keys(state.favouriteEvents).length <= 0) {
              state.favouriteEvents = {}
              state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] = [event.eveid]
            } else {
              var fav = recursiveMethod(state.favouriteEvents, 'market', event.eveid)
            }
          }
        }
      }))
    }))
  },
  sortFavouriteEvents(orderedEvents, payload) {
   // console.log(state.selectedBettype.sprtId)
    if (state.selectedMarket==3) {
      _.forEach(payload.orderedEvents, ((sportsList, skey) => {
        _.forEach(sportsList, ((events, lkey) => {
          _.forEach(events, ((event, key) => {
            if (!_.isUndefined(state.favouriteEvents)) {
              if (_.indexOf(state.favouriteLgeEvents[state.selectedBettype.sprtId], event.lgeid) >= 0) {
                payload.orderedEvents[skey][lkey][key]['isFavourite'] = true
                if(payload.favEve==undefined || payload.favEve==0){
                  if(event.rbstatus==1){
                    state.favouriteRBEventsCount+=1
                  }else{
                    state.favouriteEventsCount+=1
                  }
                }
                
              } else {
                if (_.indexOf(state.favouriteEvents[state.selectedBettype.sprtId], event.eveid) >= 0) {
                  payload.orderedEvents[skey][lkey][key]['isFavourite'] = true
                  if(payload.favEve==undefined || payload.favEve==0){
                    if(event.rbstatus==1){
                      state.favouriteRBEventsCount+=1
                    }else{
                      state.favouriteEventsCount+=1
                    }
                  }
                } else {
                  if(typeof payload.orderedEvents[skey][lkey][key] != 'object'){
                    payload.orderedEvents[skey][lkey]['isFavourite'] = false

                  }else{
                    payload.orderedEvents[skey][lkey][key]['isFavourite'] = false
                  }
                }
              }
            }
          }))
        }))
      }))
    }else if(state.selectedMarket==5){
      if(payload.isRB == 0){
        _.forEach(payload.orderedEvents, ((sportsList, skey) => {
          _.forEach(sportsList, ((events, lkey) => {
            _.forEach(events, ((event, key) => {
              if (!_.isUndefined(state.favouriteEvents)) {
                _.forEach(state.favouriteEvents, ((evelist, lskey) => {
                  if (_.indexOf(evelist, event.eveid) >= 0) {
                    payload.orderedEvents[skey][lkey][key]['isFavourite'] = true
                    if(payload.favEve==undefined || payload.favEve==0){
                      if(event.rbstatus==1){
                        state.favouriteRBEventsCount+=1
                      }else{
                        state.favouriteEventsCount+=1
                      }
                    }
                  } else {
                    if(typeof payload.orderedEvents[skey][lkey][key] != 'object'){
                      payload.orderedEvents[skey][lkey]['isFavourite'] = false
          
                    }else{
                      payload.orderedEvents[skey][lkey][key]['isFavourite'] = false
                    }
                  }
                }))
              }
            }))
          }))
        }))
      }else{
        _.forEach(payload.orderedEvents, ((events, lkey) => {
            _.forEach(events, ((event, key) => {
              if (!_.isUndefined(state.favouriteEvents)) {
                _.forEach(state.favouriteEvents, ((evelist, lskey) => {
                  if (_.indexOf(evelist, event.eveid) >= 0) {
                    payload.orderedEvents[lkey][key]['isFavourite'] = true
                    if(payload.favEve==undefined || payload.favEve==0){
                      if(event.rbstatus==1){
                        state.favouriteRBEventsCount+=1
                      }else{
                        state.favouriteEventsCount+=1
                      }
                    }
                  } else {
                    if(typeof payload.orderedEvents[lkey][key] != 'object'){
                      payload.orderedEvents[lkey]['isFavourite'] = false
          
                    }else{
                      payload.orderedEvents[lkey][key]['isFavourite'] = false
                    }
                  }
                }))
              }
            }))
          }))
      }
      
    }else{
        _.forEach(payload.orderedEvents, ((events, lkey) => {
          _.forEach(events, ((event, key) => {
            if (!_.isUndefined(state.favouriteEvents)) {
              if (_.indexOf(state.favouriteLgeEvents[state.selectedBettype.sprtId], event.lgeid) >= 0) {
                payload.orderedEvents[lkey][key]['isFavourite'] = true
                if(payload.favEve==undefined || payload.favEve==0){
                  if(event.rbstatus==1){
                    state.favouriteRBEventsCount+=1
                  }else{
                    state.favouriteEventsCount+=1
                  }
                }
                
              } else {
                // console.log('>>'+event.eveid)
                if (_.indexOf(state.favouriteEvents[state.selectedBettype.sprtId], event.eveid) >= 0) {
                  payload.orderedEvents[lkey][key]['isFavourite'] = true
                  if(payload.favEve==undefined || payload.favEve==0){
                    if(event.rbstatus==1){
                      state.favouriteRBEventsCount+=1
                    }else{
                      state.favouriteEventsCount+=1
                    }
                  }
                } else {
                  //event.isFavourite = false
                  payload.orderedEvents[lkey][key]['isFavourite'] = false
                }
              }
            }
          }))
        }))
    }
    payload.callback(payload.orderedEvents)
  },
  sortFavouriteMatchEvents(orderedEvents, payload) {
    if (payload.orderedEvents) {
      // if(!_.isUndefined(state.favouriteEvents[state.selectedMarket])){
      //   if(_.indexOf(state.favouriteEvents[state.selectedMarket][state.selectedBettype.sprtId], payload.orderedEvents.eveid) >= 0 ) {
      if (!_.isUndefined(state.favouriteEvents)) {
        if (_.indexOf(state.favouriteEvents[state.selectedBettype.sprtId], payload.orderedEvents.eveid) >= 0) {
          payload.orderedEvents.isFavourite = true
        } else {
          payload.orderedEvents.isFavourite = false
        }
      }
    }

    payload.callback(payload.orderedEvents)
  },
  // getLaugueList(context, callback) {
  getLaugueList(context, payload) {
    var date = '0'
    var apiUrl = ''
    if (this.getters.account.previewFlag == true) {
      apiUrl = _baseUrl + '/sport-league-list-preview'
    } else {
      apiUrl = _baseUrl + '/sport-league-list'
    }

    var data = {}
    var httpType = 'get'
    var selmarket = this.getters.selectedMarket
    var selsportid = this.getters.selectedBettype.sprtId

    if (this.getters.selectedMarket == this.getters.market.earlyMarket.key) {
      date = this.getters.selectedEarlyParlayDate
    }
    var plytypgrp = this.getters.selectedBettype.betTypId

    if (payload.scheduleMarket != '' && payload.scheduleMarket != undefined) {
      selmarket = payload.scheduleMarket
    }else if(this.getters.open_RBMarket && payload.scheduleMarket == ''){
      selmarket = this.getters.market.inPlayMarket.key
    }else if(this.getters.hotSchedule && payload.scheduleMarket == ''){
      selmarket = this.getters.market.hotSportMarket.key
    }

    if(this.getters.open_RBMarket && this.getters.selectedSport.sprtId=='G98'){
      selsportid = this.getters.selectedSport.sprtId
    }

    
    if(this.getters.hotSchedule && this.getters.selectedSport.sprtId=='G98'){
      selsportid = this.getters.selectedSport.sprtId
    }
    
    data = {
      sprtid: selsportid,
      schedule: selmarket,
      date: date,
      plytypgrp: plytypgrp,
      langId: window._langid,
      sort: 2,
      spread: this.getters.account.spread,
      gameMenuId: 0,
    }
    if (data.plytypgrp == '2' && this.getters.int_fullHalfTime == '2') {
      data.plytypgrp = '6'
    } else if (data.plytypgrp == '3' && this.getters.int_fullHalfTime == '2') {
      data.plytypgrp = '7'
    }
    if (this.getters.showFavEvents) {
      if (this.getters.favouriteEvents[this.getters.selectedBettype.sprtId] && Object.keys(this.getters.favouriteEvents[this.getters.selectedBettype.sprtId]).length > 0) {
        data.events = this.getters.favouriteEvents[this.getters.selectedBettype.sprtId]
      } else {
        data.events = '0' //no event sel
      }
      if (this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId] && Object.keys(this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId]).length > 0) {
        data.lgevents = this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId]
      } else {
        data.lgevents = '0' //no event sel
      }
      data.showFav = '1'
    }
    //config bettype file
    if (this.getters.selectedBettype.betTypId == '7' ||
      this.getters.selectedBettype.betTypId == '8' ||
      this.getters.selectedBettype.betTypId == '9' ||
      this.getters.selectedBettype.betTypId == '10') {
      data.plytypgrp = '1'
    } else if (this.getters.selectedBettype.betTypId == '6') { //if is outright
      httpType = 'post'
      apiUrl = _baseUrl + '/sport-outright-league'
      data = {
        sprtid: this.getters.selectedBettype.sprtId,
        lang: window._langid,
        action: '1',
      }
    }

    if (state.isGameBannerSelected) {
      data.gameMenuId = this.getters.gameBannerId
    }

    data.token = token.arr_15

    core.$ajax({
      method: httpType,
      url: apiUrl,
      data: data,
    }).done(((res) => {
      var lgeList = res.leagues
      if(this.getters.open_RBMarket) {
        this.commit('MERGE_LEAGUELIST', null)
      }
      
      if(this.getters.hotSchedule) {
        this.commit('MERGE_LEAGUELIST', null)
      }
      //Today + RB league
      // if (this.getters.arr_leagueList != null) {
      if (this.getters.merge_leagueList != null) {
        var arrLge = this.getters.merge_leagueList
        for (var i = 0; i < lgeList.length; i++) {
          var lgedata = lgeList[i]
          arrLge.push(lgedata)
        }
        lgeList = arrLge
      }
      this.commit('MERGE_LEAGUELIST', lgeList)
      // if(this.getters.merge_leagueList.length>0){
        this.commit('LEAGUELIST', this.getters.merge_leagueList)
      // }
      // this.commit('LEAGUELIST', res.leagues)

      if (payload.callback) {
        return payload.callback(res)
      }
    }).bind(this)).catch((errRes) => {
      console.log(errRes)
    })
  },
  getSportEventList(context, payload) {
    payload = payload ? payload : {}

    var ajaxData = {
      schedule: payload.market ? payload.market : state.selectedMarket,
      spread: this.getters.account.spread,
      gameMenuId: 0
    }

    if (payload.isGameBanner) {
      ajaxData.gameMenuId = this.getters.gameBannerId
    }

    ajaxData.token = payload.token

    var url = ''

    if (this.getters.account.previewFlag == true) {
      url = '/sport-event-list-preview'
    } else {
      url = '/sport-event-list'
    }

    core.$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: ajaxData,
    }).done(((res) => {
      if (!ajaxData.gameMenuId) {
        if (state.selectedMarket == state.market.inPlayMarket.key || payload.market == state.market.inPlayMarket.key) {
          this.commit('SPORT_INPLAY_EVENTS', res.totalMatch)
        } else { //is today or early
          this.commit('SPORT_ALL_EVENTS', res.totalMatch)
        }
      }
      if (payload.isGameBanner) {
        this.commit('GAME_BANNER_SPORT_COUNT', res.totalMatch)
      }
      if (payload) {
        if (payload.callback)
          return payload.callback(res)
      }
    }).bind(this)).catch((errRes) => {
      console.log(errRes)
    })
  },
  getSportCount(context, payload) {

    var url = ''

    if (this.getters.account.previewFlag == true) {
      url = '/sport-count-preview'
    } else {
      url = '/sport-count'
    }

    core.$ajax({
      method: 'get',
      url: window._baseUrl + url,
      // data: ajaxData,
    }).done(((res) => {
      this.commit('ALLSPORTCOUNT', res.allCount)
    }).bind(this)).catch((errRes) => {
      console.log(errRes)
    })
  },
  getEarlyEventCountByDate(context, payload){
    var url = ''
    if(this.getters.account.previewFlag == true){
      url = '/event-count-bydate-preview'
    }else{
      url = '/event-count-bydate'
    }
    
    core.$ajax({
      method: 'get',
      url: window._baseUrl + url,
      // data: ajaxData,
    }).done(((res)=> {
      this.commit('EARLYCOUNT_BYDATE', res.countByDate)
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  toggleSportLeague(context, payload) {
    this.commit('SPORT_LEAGUE_TOGGLE')
    if (state.bool_leagueToggle) {
      if(this.getters.selectedMarket == this.getters.market.tdyMarket.key){
        this.dispatch('getLaugueList', {
          scheduleMarket: '4',
          callback: ((res) => {
            if (payload.callback) {
              return payload.callback(res)
            }
          }).bind(this)
        })
      }else{
        if(!this.getters.open_RBMarket && this.getters.selectedMarket == this.getters.market.tdyMarket.key
          && this.getters.selectedBettype.betTypId!='5' 
          && this.getters.selectedBettype.betTypId!='6'){
          this.dispatch('getLaugueList', {scheduleMarket: this.getters.market.inPlayMarket.key})
        }
        // this.dispatch('getLaugueList', {scheduleMarket: ''})
        this.dispatch('getLaugueList', {
          scheduleMarket: '',
          callback: ((res) => {
            if (payload.callback) {
              return payload.callback(res)
            }
          }).bind(this)
        })
      }
    }
  }
}

// mutations
const mutations = {
  [types.MOREBETTOGGLE](state, payload) {
    if (payload.clear) {
      if (state.moreBetToggle.indexOf(payload.eveid) > -1) {
        let i = state.moreBetToggle.indexOf(payload.eveid)
        state.moreBetToggle.splice(i, 1)
      }

      console.log('x: ' + i)
      // state.moreBetToggle.splice(i, 1)
    } else {
      state.moreBetToggle.push(payload.eveid)
    }


    // state.moreBetToggle = payload
  },
  [types.MOREBETLOADING](state, payload) {
    state.moreBetLoading = payload
  },
  [types.SELECTEDLEAGUES](state, payload) {
    state.selectedLeagues = payload
  },
  [types.TOTALLEAGUES](state, payload) {
    state.totalLeagues = payload
  },
  [types.SPORTLEAGUE_WINDOWEVENT](state, payload) {
    state.sportLeagueWindowEvent = payload
  },
  [types.EVENTLIST](state, payload) {
    state.eventList = payload
  },
  [types.RBEVENTLIST](state, payload) {
    state.rbeventList = payload
  },
  [types.FAVRBEVENTLIST](state, payload) {
    state.favrbeventList = payload
  },

  [types.EVENT_ALLBET](state, payload) {
    state.eventAllBet = payload
  },
  [types.MAINMARKET_BET](state, payload) {
    state.mainMarketBet = payload
  },
  [types.MATCH_ALLBET](state, payload) {
    state.matchAllBet = payload
  },

  [types.SHOW_LEAGUETEAM](state, payload) {
    state.showLeagueTeam = payload
  },
  [types.SHOW_LEAGUESEARCH](state, payload) {
    state.showLeagueSearch = payload
  },
  [types.SORTEDEVENTLIST] (state, payload ) {
    state.sortedEventList = payload
  },
  // RB Event in Today
  [types.SORTEDRBEVENTLIST](state, payload) {
    state.sortedRBEventList = payload
  },
  [types.SORTEDFAVRBEVENTLIST](state, payload) {
    state.sortedFavRbEventList = payload
  },
  [types.SORTEDMATCHEVENTLIST](state, payload) {
    state.sortedMatchEventList = payload
  },
  [types.FIRSTEVENT](state, payload) {
    if(state.firstEvent && state.firstEvent.eveid){
      if(this.getters.livetv.eveid!=null && this.getters.livetv.eveid>0 && state.firstEvent.eveid!=payload.eveid){
        let tvlinkArray={};
        tvlinkArray.link = null
        tvlinkArray.eveid = null
        this.commit('LIVETV', tvlinkArray);
      }
    }
    state.firstEvent = payload
    this.commit('TESTSHOW', true)
  },
  [types.TESTSHOW](state, payload) {
    state.testshow = payload
  },
  [types.SHOWRIGHTBANNER](state, payload) {
    state.showRightBanner = payload
  },
  [types.FAVOURITEOTREVENT](state, payload) {
    if(!_.isUndefined(state.favouriteOTREvents[payload.selectedSport]) && state.favouriteOTREvents[payload.selectedSport].includes(payload.eveId)){
      var indexKy =  state.favouriteOTREvents[payload.selectedSport].indexOf(payload.eveId);
      if(indexKy!=-1){
        state.favouriteOTREvents[payload.selectedSport].splice(indexKy, 1);
      }
    }else{
      if (_.isUndefined(state.favouriteOTREvents[payload.selectedSport]) || state.favouriteOTREvents[payload.selectedSport] == null) {
        state.favouriteOTREvents[payload.selectedSport] = []
      }
      state.favouriteOTREvents[payload.selectedSport].push(payload.eveId)
    }
  },
  [types.FAVOURITEOTREVENTCOUNT](state, payload) {
    state.favouriteOTREventsCount= payload
  },
  [types.FAVOURITEEVENTCOUNT](state, payload) {
    state.favouriteEventsCount= payload
  },
  [types.FAVOURITERBEVENTCOUNT](state, payload) {
    state.favouriteRBEventsCount= payload
  },
  [types.FAVOURITEEVENT](state, payload) {
    if (payload.clear) {
      state.favouriteEvents = payload.clear ? {} : state.favouriteEvents
      state.showFavEvents = false
      if (payload.isrb == '1') {
        _.forEach(state.sortedRBEventList, ((events, eventsKey) => {
          _.forEach(events, ((event, eventKey) => {
            state.sortedRBEventList[eventsKey][eventKey].isFavourite = false
          }))
        }))
      } else {
        _.forEach(state.sortedEventList, ((events, eventsKey) => {
          _.forEach(events, ((event, eventKey) => {
            state.sortedEventList[eventsKey][eventKey].isFavourite = false
          }))
        }))
      }
      if (state.sortedMatchEventList) {
        if (state.sortedMatchEventList.eveid == payload.event.eveid) {
          state.sortedMatchEventList.isFavourite = false
        }
      }
    } else {
      let VUE = this
      function recursiveMethod(value, type, league) {
        var selectedMarket = VUE.getters.selectedMarket
        var selectedSport = VUE.getters.selectedBettype.sprtId
        if (value == null && type == 'market') {
          value = {}
          return recursiveMethod(value, 'sport', league)
        }
        if (value == null) {
          return recursiveMethod(value, 'market', league)
        }
        if (value[selectedSport] == null) {
          value[selectedSport] = []
          value[selectedSport].push(league)
          return value
        }
        value[selectedSport].push(league)
        return value;
      }
      let LgeCheck = false;
      if (!_.isUndefined(state.favouriteLgeEvents) && _.indexOf(state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId], payload.event.lgeid) >= 0) {
        _.pull(state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId], payload.event.lgeid);
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' })
        // let EveList = payload.isrb ? state.sortedRBEventList : state.sortedEventList;
        // let EveList = payload.isrb ? state.sortedFavRbEventList : state.sortedEventList;
        _.forEach(state.sortedRBEventList, ((events, eventsKey) => {
          _.forEach(events, ((event, eventKey) => {
            if (event.eveid != payload.event.eveid && event.lgeid == payload.event.lgeid) { // checked the event in league
              if (Object.keys(state.favouriteEvents).length <= 0) {
                state.favouriteEvents = {}
                state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] = [event.eveid]
                this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' })
              } else {
                var fav = recursiveMethod(state.favouriteEvents, 'market', event.eveid)
                this.commit('ACCOUNT_FAV', { favdt: fav, isFavLeague: '0' })
              }
            } else if (event.eveid == payload.event.eveid && event.lgeid == payload.event.lgeid) {
              LgeCheck = true;
            }
          }))
        }))
        _.forEach(state.sortedEventList, ((events, eventsKey) => {
          _.forEach(events, ((event, eventKey) => {
            if (event.eveid != payload.event.eveid && event.lgeid == payload.event.lgeid) { // checked the event in league
              if (Object.keys(state.favouriteEvents).length <= 0) {
                state.favouriteEvents = {}
                state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] = [event.eveid]
                this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' })
              } else {
                var fav = recursiveMethod(state.favouriteEvents, 'market', event.eveid)
                this.commit('ACCOUNT_FAV', { favdt: fav, isFavLeague: '0' })
              }
            } else if (event.eveid == payload.event.eveid && event.lgeid == payload.event.lgeid) {
              LgeCheck = true;
            }
          }))
        }))
        if (state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId].length <= 0) {
          delete state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId]
          if (Object.keys(state.favouriteLgeEvents).length <= 0) {
            state.favouriteLgeEvents = {}
          }
          this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' })
        }
      }
      
      if (!_.isUndefined(state.favouriteEvents) && _.indexOf(state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId], payload.event.eveid) >= 0) {
        _.pull(state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId], payload.event.eveid)
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' })
        if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].length <= 0) {
          delete state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId]
          if (Object.keys(state.favouriteEvents).length <= 0) {
            state.favouriteEvents = {}
          }
          this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' })
        }
      } else if(!LgeCheck){ // add fav by event
        if(Object.keys(state.favouriteEvents).length <= 0){
          state.favouriteEvents = {}
          state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] = [payload.event.eveid]
          this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' })
        }else{
          var fav = recursiveMethod(state.favouriteEvents, 'market', payload.event.eveid)
          this.commit('ACCOUNT_FAV', { favdt: fav, isFavLeague: '0' })
        }
      }

      if (payload.isrb && state.selectedMarket!=3 && !this.getters.hotSchedule) {
        _.forEach(state.sortedRBEventList, ((events, eventsKey) => {
          _.forEach(events, ((event, eventKey) => {
            if (event.eveid == payload.event.eveid) {
              if (!payload.event.isFavourite) {
                state.sortedRBEventList[eventsKey][eventKey].isFavourite = true
              } else {
                state.sortedRBEventList[eventsKey][eventKey].isFavourite = !payload.event.isFavourite
              }
            }
          }))
        }))
        this.commit('FAVOURITERBEVENTCOUNT', 0)
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedRBEventList,
          callback: ((res) => {
            this.commit('SORTEDRBEVENTLIST', _.cloneDeep(res))
          })
        })
      }else if (state.selectedMarket==3 && !this.getters.hotSchedule) {
        this.commit('FAVOURITERBEVENTCOUNT', 0)
        _.forEach(state.sortedEventList, ((sportslist, SportKey) => {
          _.forEach(sportslist, ((events, eventsKey) => {
            _.forEach(events, ((event, eventKey) => {
              if (event.eveid == payload.event.eveid) {
                if (!payload.event.isFavourite) {
                  state.sortedEventList[SportKey][eventsKey][eventKey].isFavourite = true
                } else {
                  state.sortedEventList[SportKey][eventsKey][eventKey].isFavourite = !payload.event.isFavourite
                }
              }
            }))
          }))
        }))
      }else if (state.selectedMarket==5 && this.getters.hotSchedule) {
        if(payload.event.rbstatus == 1){
          _.forEach(state.sortedRBEventList, ((sportslist, SportKey) => {
            _.forEach(sportslist, ((events, eventsKey) => {
              _.forEach(events, ((event, eventKey) => {
                if (event.eveid == payload.event.eveid) {
                  if (!payload.event.isFavourite) {
                    state.sortedRBEventList[SportKey][eventsKey][eventKey].isFavourite = true
                  } else {
                    state.sortedRBEventList[SportKey][eventsKey][eventKey].isFavourite = !payload.event.isFavourite
                  }
                }
              }))
            }))
          }))
          this.commit('FAVOURITEEVENTCOUNT', 0)
          this.commit('FAVOURITERBEVENTCOUNT', 0)
          this.dispatch('sortFavouriteEvents', {
            orderedEvents: state.sortedRBEventList,
            isRB: 0,
            callback: ((res) => {
              this.commit('SORTEDRBEVENTLIST', _.cloneDeep(res))
            })
          })
        }else{ 
          _.forEach(state.sortedEventList, ((sportslist, SportKey) => {
            _.forEach(sportslist, ((events, eventsKey) => {
              _.forEach(events, ((event, eventKey) => {
                if (event.eveid == payload.event.eveid) {
                  if (!payload.event.isFavourite) {
                    state.sortedEventList[SportKey][eventsKey][eventKey].isFavourite = true
                  } else {
                    state.sortedEventList[SportKey][eventsKey][eventKey].isFavourite = !payload.event.isFavourite
                  }
                }
              }))
            }))
          }))
          this.commit('FAVOURITEEVENTCOUNT', 0)
          this.commit('FAVOURITERBEVENTCOUNT', 0)
          this.dispatch('sortFavouriteEvents', {
            orderedEvents: state.sortedEventList,
            isRB: 0,
            callback: ((res) => {
              this.commit('SORTEDEVENTLIST', _.cloneDeep(res))
            })
          })
        }
      } else {
        _.forEach(state.sortedEventList, ((events, eventsKey) => {
          _.forEach(events, ((event, eventKey) => {
            if (event.eveid == payload.event.eveid) {
              if (!payload.event.isFavourite) {
                state.sortedEventList[eventsKey][eventKey].isFavourite = true
              } else {
                state.sortedEventList[eventsKey][eventKey].isFavourite = !payload.event.isFavourite
              }
            }
          }))
        }))
      }
      if(!this.getters.hotSchedule){
        this.commit('FAVOURITEEVENTCOUNT', 0)
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedEventList,
          isRB: 0,
          callback: ((res) => {
            this.commit('SORTEDEVENTLIST', _.cloneDeep(res))
          })
        })
      }
    }
  },

  [types.FAVOURITELGEVENT](state, payload) {
    if (payload.clear) {
      payload.clear ? {} : state.favouriteEvents
      state.showFavEvents = false
      if (payload.isrb == '1') {
        _.forEach(state.sortedRBEventList, ((events, eventsKey) => {
          _.forEach(events, ((event, eventKey) => {
            state.sortedRBEventList[eventsKey][eventKey].isFavourite = false
            if(event.rbstatus==1){
              state.favouriteRBEventsCount-=1
            }else{
              state.favouriteEventsCount-=1
            }
          }))
        }))
      } else {
        _.forEach(state.sortedEventList, ((events, eventsKey) => {
          _.forEach(events, ((event, eventKey) => {
            state.sortedEventList[eventsKey][eventKey].isFavourite = false
            if(event.rbstatus==1){
              state.favouriteRBEventsCount-=1
            }else{
              state.favouriteEventsCount-=1
            }
          }))
        }))
      }
      
      if (state.sortedMatchEventList) {
        if (state.sortedMatchEventList.eveid == payload.eveid) {
          state.sortedMatchEventList.isFavourite = false
          if(event.rbstatus==1){
            state.favouriteRBEventsCount+=1
          }else{
            state.favouriteEventsCount+=1
          }
        }
      }
    } else {
      let VUE = this
      function recursiveMethod(value, type, league) {
        var selectedMarket = VUE.getters.selectedMarket
        var selectedSport = VUE.getters.selectedBettype.sprtId
        if (value == null && type == 'market') {
          value = {}
          return recursiveMethod(value, 'sport', league)
        }
        if (value == null) {
          return recursiveMethod(value, 'market', league)
        }
        if (value[selectedSport] == null) {
          value[selectedSport] = []
          value[selectedSport].push(league)
          return value
        }
        value[selectedSport].push(league)
        return value;
      }

      if (!_.isUndefined(state.favouriteEvents) && _.indexOf(state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId], payload.eveid) >= 0) {
        state.favouriteEvents = {}
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' })
      } else {

        if (Object.keys(state.favouriteEvents).length <= 0) {
          state.favouriteEvents = {}
          this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' })
        }
      }

      if (!_.isUndefined(state.favouriteLgeEvents) && _.indexOf(state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId], payload.lgeid) >= 0) {
        _.pull(state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId], payload.lgeid)
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' })
        if (state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId].length <= 0) {
          delete state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId]
          if (Object.keys(state.favouriteLgeEvents).length <= 0) {
            state.favouriteLgeEvents = {}
          }
          this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' })
        }
      } else {
        if (Object.keys(state.favouriteLgeEvents).length <= 0) {
          state.favouriteLgeEvents = {}
          state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId] = [payload.lgeid]
          this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' })
        } else {
          var fav = recursiveMethod(state.favouriteLgeEvents, 'market', payload.lgeid)
          this.commit('ACCOUNT_FAV', { favdt: fav, isFavLeague: '0' })
        }
      }
      
      if (payload.isrb == '1' && (state.selectedMarket==3 || this.getters.hotSchedule)) {
        _.forEach(state.sortedEventList, ((SportList, sportKey) => {
          _.forEach(SportList, ((events, eventsKey) => {
            _.forEach(events, ((event, eventKey) => {
              if (event.lgeid == payload.lgeid) {
                if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] && state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].includes(event.eveid)) {
                  _.pull(state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId], event.eveid)
                  if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].length <= 0) {
                    delete state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId]
                    if (Object.keys(state.favouriteEvents).length <= 0) {
                      state.favouriteEvents = {}
                      vueCookie.set(window.STORE.getters.account.acccode + '_accfav_event', JSON.stringify(state.favouriteEvents))
                    }
                  }
                }
                if (payload.lgeChk) {
                  state.sortedEventList[sportKey][eventsKey][eventKey].isFavourite = false
                } else {
                  state.sortedEventList[sportKey][eventsKey][eventKey].isFavourite = true
                }
              }
            }))
          }))  
        }))
      } else {
        _.forEach(state.sortedRBEventList, ((events, eventsKey) => {
          _.forEach(events, ((event, eventKey) => {
            if (state.sortedRBEventList[eventsKey][eventKey].lgeid == payload.lgeid) {
              if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] && state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].includes(state.sortedRBEventList[eventsKey][eventKey].eveid)) {
                _.pull(state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId], state.sortedRBEventList[eventsKey][eventKey].eveid)
                if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].length <= 0) {
                  delete state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId]
                  if (Object.keys(state.favouriteEvents).length <= 0) {
                    state.favouriteEvents = {}
                    this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' })
                  }
                }
              }
              if (payload.lgeChk) {
                state.sortedRBEventList[eventsKey][eventKey].isFavourite = false
              } else {
                state.sortedRBEventList[eventsKey][eventKey].isFavourite = true
              }
            }
          }))
        }))
        this.commit('FAVOURITERBEVENTCOUNT', 0)
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedRBEventList,
          callback: ((res) => {
            this.commit('SORTEDRBEVENTLIST', _.cloneDeep(res))
          })
        })
        _.forEach(state.sortedEventList, ((events, eventsKey) => {
          _.forEach(events, ((event, eventKey) => {
            if (state.sortedEventList[eventsKey][eventKey].lgeid == payload.lgeid) {
              if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] && state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].includes(state.sortedEventList[eventsKey][eventKey].eveid)) {
                _.pull(state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId], state.sortedEventList[eventsKey][eventKey].eveid)
                if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].length <= 0) {
                  delete state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId]
                  if (Object.keys(state.favouriteEvents).length <= 0) {
                    state.favouriteEvents = {}
                    this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '' })
                  }
                }
              }
              if (payload.lgeChk) {
                state.sortedEventList[eventsKey][eventKey].isFavourite = false
              } else {
                state.sortedEventList[eventsKey][eventKey].isFavourite = true
              }
            }
          }))
        }))
      }
      //test comment - on click fav, will cause right menu event gone
      // if (state.sortedMatchEventList) {
      //   if (state.sortedMatchEventList.eveid == payload.eveid) {
      //     if (!payload.isFavourite) {
      //       state.sortedMatchEventList.isFavourite = true
      //     } else {
      //       state.sortedMatchEventList.isFavourite = !payload.isFavourite
      //     }
      //   }
      // }
      this.commit('FAVOURITEEVENTCOUNT', 0)
      if (state.selectedMarket==3 && !state.showFavEvents) {
        this.commit('FAVOURITERBEVENTCOUNT', 0)
      }else if(this.getters.hotSchedule && !state.showFavEvents){
        this.commit('FAVOURITERBEVENTCOUNT', 0)
      }
      this.dispatch('sortFavouriteEvents', {
        orderedEvents: state.sortedEventList,
        callback: ((res) => {
          this.commit('SORTEDEVENTLIST', _.cloneDeep(res))
        })
      })
      //test comment - on click fav, will cause right menu event gone
      // this.dispatch('sortFavouriteMatchEvents', {
      //   orderedEvents: state.sortedMatchEventList,
      //   callback: ((res) => {
      //     this.commit('SORTEDMATCHEVENTLIST', _.cloneDeep(res))
      //   })
      // })
    }
  },
  [types.FAVOURITEEVENT_FIRSTLOAD](state, payload) {
    var favEve_cookie = vueCookie.get(this.getters.account.acccode+'_accfav_event')
    var favEveObj     = JSON.parse(favEve_cookie)

    if(Object.keys(favEve_cookie).length>0){
      state.favouriteEvents = favEveObj
    }
  },
  [types.FAVOURITELGEVENT_FIRSTLOAD](state, payload) {
    var favLgEve_cookie = vueCookie.get(this.getters.account.acccode+'_accfavlg_event')
    var favLgEveObj     = JSON.parse(favLgEve_cookie)

    if(Object.keys(favLgEveObj).length>0){
      state.favouriteLgeEvents = favLgEveObj
    }
  },

  [types.TOTALPAGE](state, payload) {
    state.totalPage = payload
  },

  [types.SPORTLIST](state, payload) {
    state.sportList = payload
  },

  [types.BETTYPELIST](state, payload) {
    state.bettypeList = payload
  },

  [types.SPORTBETTYPELIST](state, payload) {
    state.sportBettypeList = payload
  },

  [types.ODDTYPESLIST](state, payload) {
    state.oddTypesList = payload
  },

  [types.EARLYPARLAYDATELIST](state, payload) {
    state.earlyParlayDateList = payload
  },

  [types.SELECTEDEARLYPARLAYDATE](state, payload) {
    state.selectedEarlyParlayDate = payload
  },

  [types.SELECTED_PAGE](state, payload) {
    state.selectedPage = payload
  },

  [types.SELECTED_ALLBET](state, payload) {
    state.selectedAllBet = payload
    this.commit('PARLAY_SELECTED', { update: false })
  },

  [types.SELECTED_ALLBETNEW](state, payload) {
    state.selectedAllBetNew = payload
    this.commit('PARLAY_SELECTED', { update: false })
  },
  [types.SELECTED_MATCHALLBET](state, payload) {
    state.selectedMatchAllBet = payload
  },

  [types.SELECTED_SORT](state, payload) {
    state.selectedSort = payload
  },
  [types.SELECTED_SHOW](state, payload) {
    state.selectedShow = payload
  },
  [types.SELECTED_MARKET](state, payload) {
    state.selectedMarket = payload
  },

  [types.SELECTED_SPORT](state, payload) {
    state.selectedSport = payload
  },

  [types.SELECTED_BETTYPE](state, payload) {
    state.selectedBettype = payload
    // this.commit('FIRSTEVENT', [])
    if(payload && payload.sprtId=='N1' && payload.tmpltId=='1' && !state.miniNormal && !this.getters.simpleSport){
      if(!_.isUndefined(state.unfold_AllSc[payload.sprtId]) && !_.isUndefined(state.unfold_AllSc[payload.sprtId][payload.tmpltId])){
        state.show_Unfold = (!state.unfold_AllSc[payload.sprtId][payload.tmpltId]) ? true : false
        state.show_Fold = (!state.unfold_AllSc[payload.sprtId][payload.tmpltId]) ? false : true

        this.commit('UNFOLD_ALLSC', state.unfold_AllSc[payload.sprtId][payload.tmpltId])
      }
      
    }else{
      state.show_Unfold = false
      state.show_Fold = false 
      this.commit('UNFOLD_ALLSC', false)
    }
    this.commit('FRAME_RESIZE', 1)
  },

  [types.SELECTED_MARKET](state, payload) {
    state.selectedMarket = payload
  },

  PREV_MARKET(state, payload) {
    state.prevMarket = payload
  },

  [types.CHANGE_ODDS](state, payload) {
    state.changeOdds = payload
  },

  [types.SPORTTABLELANG](state, payload) {
    state.sportTableLang = payload
  },

  [types.SPORTALLBETLANG](state, payload) {
    state.sportAllBetLang = payload
  },

  [types.SPORT_LEAGUE_TOGGLE](state) {
    state.bool_leagueToggle = (state.bool_leagueToggle === false ? true : false)
    // if (state.bool_leagueToggle) {
    //   if(!this.getters.open_RBMarket && this.getters.selectedMarket == this.getters.market.tdyMarket.key
    //     && this.getters.selectedBettype.betTypId!='5' 
    //     && this.getters.selectedBettype.betTypId!='6'){
    //     this.dispatch('getLaugueList', {scheduleMarket: this.getters.market.inPlayMarket.key})
    //   }
    //   this.dispatch('getLaugueList', {scheduleMarket: ''})


    //   this.$store.dispatch('getLaugueList', {
    //     scheduleMarket: '',
    //     callback: ((res) => {
    //       if(this.$store.getters.arr_leagueList!=undefined){
    //         this.$store.commit('SELECTEDLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
    //         this.$store.commit('TOTALLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
    //       }
    //     }).bind(this)
    //   })

    // }
  },

  [types.SPORT_FULLHALF_TIME](state, payload) {
    state.int_fullHalfTime = payload
  },

  [types.LEAGUELIST](state, payload) {
    state.arr_leagueList = payload
  },
  [types.MERGE_LEAGUELIST](state, payload) {
    state.merge_leagueList = payload
  },

  [types.SELECTED_LEAGUELIST](state, payload) {
    state.arr_selectedLeagueList = payload
  },

  [types.SPORT_INPLAY_EVENTS](state, payload) {
    state.sportInPlayEvents = payload
  },

  [types.SPORT_ALL_EVENTS](state, payload) {
    state.sportAllEvents = payload
  },

  [types.SPORT_SHOW_FAV_EVENTS](state, payload) {
    state.showFavEvents = payload
  },

  [types.SPORT_PREVIOUS_IS_MULP](state, payload) {
    state.sportPrevIsMulp = payload
  },
  [types.HIGHLIGHT_CELL](state, payload) {
    state.highlightedCell = payload
  },
  [types.PARLAY_SELECTED](state, payload) {
    if (payload == null) {
      state.parlaySelected = payload
      $('td').removeClass('highlightedP')
      return
    }
    if (this.getters.selectedBettype.betTypId!=undefined && this.getters.selectedBettype.betTypId != "5") {
      return
    }
    if (payload.update || payload.update == false) {
      $('td').removeClass('highlightedP')
      EventBus.$emit('sportSelectedAllBetChange')
      return
    }
    if (payload.remove) {
      if(state.parlaySelected){
        delete state.parlaySelected[payload.eveid]
      }
      if (state.parlaySelected && Object.keys(state.parlaySelected).length <= 0) {
        $('td').removeClass('highlightedP')
        state.parlaySelected = null
        return
      }
      $('td').removeClass('highlightedP')
      _.forEach(state.parlaySelected, function (value, key) {
        value.addClass('highlightedP')
      })
      return
    }
    if (!state.parlaySelected) {
      state.parlaySelected = {}
    }
    state.parlaySelected[payload.eveid] = payload.class

    $('td').removeClass('highlightedP')
    _.forEach(this.getters.betForm, function (value, key) {
      $('.' + value.uniqueId).closest('td').addClass('highlightedP')
    })
  },
  [types.GAMEBANNER_SELECTED](state, payload) {
    state.isGameBannerSelected = payload
  },
  [types.ALLSPORTCOUNT](state, payload) {
    state.allSportCount = payload
  },
  [types.CHECKED_BALANCE](state, payload) {
    state.checked = payload
  },
  [types.FOLDOPEN_ALLBET](state, payload) {
    state.foldopenAllBet = payload
  },
  [types.FOLDOPEN_FIRSTEVENT](state, payload) {
    state.foldopenFirstEvent = payload
  },
  [types.IS_TODAYRB](state, payload) {
    state.istodayRB = payload
  },
  [types.OPEN_RBMARKET](state, payload) {
    state.open_RBMarket = payload
  },
  [types.SELECTED_INPLAYSPORT](state, payload) {
    state.selectedInPlaySport = payload
  },
  [types.ALLBET_RELOADING](state, payload) {
    state.allBetReloading = payload
  },
  [types.R_ALLBET_RELOADING](state, payload) {
    state.right_allBetReloading = payload
  },
  [types.EARLYCOUNT_BYDATE] (state, payload) {
    state.arr_earlyEventCountByDate = payload
  },
  [types.SHOW_UNFOLD] (state, payload) {
    state.show_Unfold = payload
  },
  [types.SHOW_FOLD] (state, payload) {
    state.show_Fold = payload
  },
  [types.SELECTED_ALLBETTAB] (state, payload) {
    if(payload.ab != undefined && payload.ab!=''){
      state.selected_AllBetTab.ab = payload.ab
    }
    if(payload.firstEvent != undefined && payload.firstEvent!=''){
      state.selected_AllBetTab.firstEvent = payload.firstEvent
    }
  },
  
  [types.UNFOLD_ALLSC] (state, payload) {
    var sprt = state.selectedBettype.sprtId
    var tmp = state.selectedBettype.tmpltId
    if(sprt=='N1' && tmp=='1'){
      state.unfold_AllSc[sprt][tmp] = payload
    }
    this.commit('FRAME_RESIZE', 1)
  },
  [types.MINI_NORMAL] (state, payload) {
    
    if(payload==1 || payload==2){
      $('#leftBarNormalScroll').getNiceScroll().remove();
      $('#miniScroll').show();
      $('#normalScroll').hide();
    }else{
      $('#leftBarMiniScroll').getNiceScroll().remove();
      $('#miniScroll').hide();
      $('#normalScroll').show();
    }
    if(payload!==1 && payload!==0){  // click use
      if(payload==2){
        state.miniNormal = 1

      }else{
        state.miniNormal = 0
      }
      let resizeable={};
      resizeable.LeftPageStatus=payload
      this.commit('FRAME_WH', resizeable)
    }else{ // resize use 
      state.miniNormal = payload
    }
    if(state.miniNormal==1){
      $('#leftBarMiniScroll').show();
      $('#miniScroll').niceScroll({  
          horizrailenabled: false,
          autohidemode: false, 
          scrollbarid:'leftBarMiniScroll',
          cursorborder: "0px solid #fff", 
          zindex:48,
          railoffset: { left:10 },
          cursordragontouch : true,
      })
    }else{
      $('#leftBarNormalScroll').show();
      $('#normalScroll').niceScroll({  
          horizrailenabled: false,
          autohidemode: false, 
          scrollbarid:'leftBarNormalScroll',
          cursorborder: "0px solid #fff", 
          zindex:45,
          railoffset: { left:10 },
          cursordragontouch : true,
      })
    }
  },
  [types.FRAME_WH] (state, payload) {
    /*
     width:{
      minFull:1440, // Window minimun Width
      currentWidth :window.innerWidth, // Current Window Width
      LeftPage_normal:234,
      LeftPage_mini :69,
      LeftPage_current : window.innerWidth > 1440 ? 234:69,
      CenterPage_min :775,
      CenterPage_current :775, // Current center odd page width
      RightPage_min :430,
      RightPage_current :430, // Current right odd page width
    },
    height:{
      header:96,
      currentHeight:window.innerHeight
    }
    */
    var resizeWidth = false;
    // Resize center page
    if(payload.centerPage != undefined && payload.centerPage!=''){
      if(parseFloat(state.frameWidthHeight.width.CenterPage_current)!=parseFloat(payload.centerPage)){
        state.frameWidthHeight.width.CenterPage_current = payload.centerPage
      }
    }

    // Resize right page
    if(payload.rightPage != undefined && payload.rightPage!=''){
      if(parseFloat(state.frameWidthHeight.width.RightPage_current)!=parseFloat(payload.rightPage)){
        state.frameWidthHeight.width.RightPage_current = payload.rightPage
      }
    }

    // Resize Height
    if(payload.currentHeight != undefined && payload.currentHeight!=''){
      if(parseFloat(state.frameWidthHeight.height.currentHeight)!=parseFloat(payload.currentHeight)){
        state.frameWidthHeight.height.currentHeight = payload.currentHeight
      }
    }

    // Resize Width
    if(payload.currentWidth != undefined && payload.currentWidth!=''){
      var currentWidthSet = state.frameWidthHeight.width.currentWidth
      var minFull = this.getters.frameWidthHeight.width.minFull;
      if(parseFloat(state.frameWidthHeight.width.currentWidtht)!=parseFloat(payload.currentWidth)){
        state.frameWidthHeight.width.currentWidth = parseFloat(payload.currentWidth)
        currentWidthSet =parseFloat(payload.currentWidth)
      }
      if(currentWidthSet < minFull){
        this.commit('MINI_NORMAL', 1)
        this.commit('UNFOLD_ALLSC', false)
        state.show_Unfold = false
        state.show_Fold = false 
        state.frameWidthHeight.width.LeftPage_current = state.frameWidthHeight.width.LeftPage_mini
      }else{
        this.commit('MINI_NORMAL', 0)
        var sprt = state.selectedBettype.sprtId
        var tmp = state.selectedBettype.tmpltId
        if(sprt=='N1' && tmp=='1'){
          state.show_Unfold = true
        }
        state.frameWidthHeight.width.LeftPage_current = state.frameWidthHeight.width.LeftPage_normal
      }
      resizeWidth=true;
    }

    // Resize Width When mini page click show hide 
    if(payload.LeftPageStatus != undefined && payload.LeftPageStatus!=''){
      if(payload.LeftPageStatus==2){
        state.frameWidthHeight.width.LeftPage_current = state.frameWidthHeight.width.LeftPage_mini
      }else{
        state.frameWidthHeight.width.LeftPage_current = state.frameWidthHeight.width.LeftPage_normal
      }
      resizeWidth=true;
    }

    if(resizeWidth){ // which action need resize  center and right page only call
      this.commit('FRAME_RESIZE', 1)
    }
  },
  [types.FRAME_RESIZE] (state, payload) {  // Recal center and right odd page width
    var currentWidthSet = window.innerWidth;
    var minFull = this.getters.frameWidthHeight.width.minFull;
    var leftPage =this.getters.frameWidthHeight.width.LeftPage_current;
    var rightPage = this.getters.frameWidthHeight.width.RightPage_min;
    if(currentWidthSet <= minFull){
      currentWidthSet=minFull;
    }else{
      rightPage = ((currentWidthSet - minFull) /5) + rightPage;
      if(rightPage> this.getters.frameWidthHeight.width.RightPage_max){
        rightPage=this.getters.frameWidthHeight.width.RightPage_max
      }
    }
    if(this.getters.selectedBettype && this.getters.selectedBettype.sprtId!=undefined){
      var sprt = this.getters.selectedBettype.sprtId
      var tmp = this.getters.selectedBettype.tmpltId
      if(!_.isUndefined(this.getters.unfold_AllSc[sprt]) && !_.isUndefined(this.getters.unfold_AllSc[sprt][tmp]) && this.getters.unfold_AllSc[sprt][tmp]){
        rightPage=0
      }
    }
    var centerPage = currentWidthSet - rightPage - leftPage;
    let resizeable={};
    
    resizeable.rightPage=rightPage;
    resizeable.centerPage=centerPage;
    this.commit('FRAME_WH', resizeable)
  },
  [types.LIVETV] (state, payload){
      state.livetv.eveid = payload.eveid
      state.livetv.link = payload.link
      EventBus.$emit('rightScoreBoard',true);
  },
  [types.FILTER_EVENT] (state, payload) {
    state.filterEventArr = payload
  },

  [types.SHOW_RBLGEEVE] (state, payload) {
    state.showRBLgeEve = payload
  },

  [types.SHOW_LGEEVE] (state, payload) {
    state.showLgeEve = payload
  },
  [types.IS_CHANGE_TEMPLATE] (state, payload) {
    state.isChangeTemplate = payload
  },
  [types.SELECTED_EVEID] (state, payload) {
    state.selectedEventId = payload
  },

  [types.IS_PARLAY_TAB](state, payload) {
    state.isParlayTab = payload
    if(!window.allowRbParlay && this.getters.isBetParlay && this.getters.betForm.length == 0 && !payload) {
      this.commit("IS_BETPARLAY", false);
    }
  },
  [types.PREV_BETTYPE](state, payload) {
    state.previousBettype = payload
  },
  [types.GAME_BANNER_SPORT_COUNT](state, payload) {
    state.gameBannerSportCount = payload
  },
  [types.GAME_BANNER_SPORT_ID](state, payload) {
    state.gameBannerSportId = payload
  },
  [types.RIGHT_BOARD_CHG](state, payload) {
    state.rightBoardChange = payload
  },
  [types.SIMPLE_SPORT](state, payload) {
    state.simpleSport = payload
  },
  [types.HOT_SCHEDULE](state, payload) {
    state.hotSchedule = payload
  },
  [types.HOT_SPORTLIST](state, payload) {
    state.hot_sportList = payload
  },
  SPECIAL_EVENT(state, payload) {
    state.specialEvent = payload
  },
  SPECIAL_EVENT_LIST(state, payload) {
    state.specialEventList = payload
  },
  REFRESHTOGGLE(state, payload) {
    state.refreshToggle = payload
  },
  SHOW_UP_DOWN(state, payload) {
    state.ShowUpDown = payload
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/wob/vue/store/modules/sport.js